export const sr = {
    addDatabase: {
        addDatabase: "Dodavanje datoteke",
        addFromFile: "Dodavanje iz arhiva",
        analyse: "Analyse",
        analysingYourData: "Analysing your data",
        createFromExcel: "Create from Excel",
        databaseImport: "Database import",
        databaseNotImported: "Import has finished with errors",
        databasePrepared: "Database successfully prepared",
        excelFile: "Excel file",
        fileInformation: "File information",
        fixErrors: "To continue please fix following errors and retry",
        importingYourData: "Importing your data",
        productFilesPath: "Product files path",
        productImagesPath: "Product images path"
    },
    availablePrice: {
        allPackage: "All packages",
        onePackage: "One package",
        priceType: "Vrsta cene",
        setPriceVatVisibility: "Set VAT visibility",
        setVisibilityAndOrder: "Podesite vidljivost i redosled vrsta cena",
        withAndWithoutVat: "Oba sa i bez PDV-a",
        withVat: "Samo sa PDV-om",
        withoutVat: "Samo bez PDV-a"
    },
    barvis: {
        base: "Ime baze",
        bigCanSize: "Velike kante",
        coating: "Premaz",
        identifier: "Identifikator",
        laboratory: "Laboratorija",
        orderOverview: "Pregled narudÅ¾be",
        rank: "Rang",
        smallCanSize: "Male kante"
    },
    basicSetup: {
        alreadyLoggedIn: "VeÄ ste ulogovani kao %{login}.",
        askSupplier: "Obratite se svom dobavljaÄu softvera da vam dodeli viÅ¡e licenci.",
        asterisk: "Predmeti oznaÄeni zvezdicom moraju biti popunjeni.",
        identificationKeys: "Identification keys",
        importCustomData: "Ako je mogucÌe, unesite svoje prilagoÄene podatke s prethodnog softvera za doziranje.",
        learnIdentification: "Saznajte identifikacione kljuÄeve od svog dobavljaÄa softvera.",
        login: "SledecÌi koraci poÄetnog postavljanja zahtevaju administratorska prava.",
        noDatabase: "JoÅ¡ nije dodana nijedna baza podataka, mora biti dodata barem jedna.",
        offlineLicensing: "Offline licensing",
        productSelection: "Product selection",
        registrationForm: "Registration form",
        seeQuestionMark: "Pogledajte male upitnike da biste saznali viÅ¡e o podeÅ¡avanju.",
        selectDefaultPrinter: "Izaberite zadani Å¡tampaÄ i podesite dodatnu konfiguraciju.",
        selectDefaultTemplate: "Izaberite zadane obrasce od vecÌ postojecÌih, kreirajte nove obrasce ili uÄitajte svoje.",
        selectDispenser: "Izaberite tip dispenzera koji koristite.",
        selectLanguage: "Izaberite VaÅ¡ jezik",
        selectProducts: "Izaberite jedan od dostupnih proizvoda koji Å¾elite da aktivirate.",
        selectSpectroType: "Izaberite vrstu spektrometra koji koristite.",
        setAdditionalPrinterOptions: "Podesite dodatne opcije Å¡tampaÄa.",
        setAutomaticUpdates: "Podesite opcije automatskog aÅ¾uriranja.",
        setCustomItems:
            "Podesite prilagoÄene stavke i vidljivost podataka. Pomerite prema dole da biste videli viÅ¡e opcija.",
        setEnvironment: "Podesite celokupno okruÅ¾enje softvera. Pomerite prema dole da biste videli viÅ¡e opcija.",
        setFormulaRepresentation: "Podesite reprezentaciju formule. Pomerite prema dole da biste videli viÅ¡e opcija.",
        summary:
            "MoÅ¾ete da promenite ove postavke u bilo koje vreme i pronaÄete joÅ¡ viÅ¡e opcija konfiguracije. UÅ¾ivajte u koriÅ¡cÌenju %{name}!",
        summarySuccess: "Sve je spremno!"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "Batch number: %{batchNumber}",
        colorantIsDefective: "The canister is filled with a defective batch of colorant. Do not use this batch.",
        defectiveInfoLine1: "Please do not use colorant",
        defectiveInfoLine2: "with this batch number.",
        emptyQuickTint: "Empty the canister using Quick tint.",
        warningInfoLine1: "Colorant",
        warningInfoLine2: "with this batch number may be damaged."
    },
    canisterLevel: {
        canisterLevel: "Podesi nivo kanistera",
        criticalLevelCanister: "KritiÄni nivoi u kanistrima",
        fillToMax: "Napunite do vrha",
        maxDispenseLevel: "Dozirajte maksimum",
        otherCanisters: "Ostali nivoi kanistera",
        warningLevelCanister: "Upozorenje nivoa kanistera"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "Batch number of filling",
        ufiCodeStatus: "UFI code status"
    },
    canistersTab: {
        availableServiceActions: "Dostupne Akcije Servisa",
        canisterInformation: "Informacije o kanisterima",
        canisterPreview: "Pregled kanistera",
        currentLevel: "Trenutni nivo",
        errors: "GreÅ¡ke",
        fillState: "Stanje punjenja",
        fillToMax: "Napunite do vrha",
        fillingAmount: "Filling amount",
        finalLevel: "Final level",
        minimumAmount: "Minimalna koliÄina",
        minimumLevel: "Minimalni nivo",
        moveTableToRefill: "Pomerite sto da bi dopunili",
        refillNoAmount: "Nije unesen iznos",
        refillOverLimit: "Unesena koliÄina prelazi maksimalni kapacitet kanistera",
        refillSummary: "%{amount} %{unit} of the colorant %{colorant} will be added to the canister %{canisterId}.",
        systemWarningAmount: "Sistem upozoravajuÄeg koliÄina ",
        warningAmount: "UpozoravajuÄa koliÄina"
    },
    changeDatabase: {
        changeDatabase: "Promenite datoteku",
        databaseWarning: "Database %{databaseName} cannot be used due to"
    },
    changelog: {
        allVersion: "All versions",
        changelog: "Changelog",
        link: "Link",
        links: "Links",
        version: "Version",
        versionFilter: "Version filter"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal: "There is not enough colorant in the canisters for %{numOfPackages} packages.",
        fillAdditionally: "Fill additionally",
        refillToMax: "Refill to max"
    },
    cleanChannels: {
        cleanAllChannels: "IzbriÅ¡ite sve kanale",
        cleanChannels: "IzbriÅ¡ite kanale",
        cleaningTime: "Vreme ÄiÅ¡Äenja",
        selectChannels: "Odaberite kanale",
        startCleaning: "Pokrenite ÄiÅ¡Äenje"
    },
    clientServerSettings: {
        activeServer: "Aktivan server",
        addNewServer: "Dodajte nov server",
        availableServers: "Drugi dostupni serveri",
        clientIdentifier: "Identifikator klijenta",
        clientServerSettings: "PodeÅ¡avanja klijenta/servera",
        disabledStatus: "OnemoguÄen",
        editServer: "Izmenite server",
        fillRequiredFields: "Obavezna polja moraju biti popunjena",
        noOtherServers: "Ne postoje drugi dostupni serveri",
        offlineStatus: "offline",
        onlineStatus: "online",
        port: "Port",
        serverName: "Ime servera",
        serverNameMissing: "Ime servera mora biti popunjeno",
        stabileConnection: "Da biste osigurali stabilnu vezu, koristite statiÄku IP adresu.",
        wrongFormatIp: "PogreÅ¡an format IP adrese"
    },
    colorSearchTab: {
        notEveryItemSelected: "One or more items are not selected"
    },
    colorTab: {
        colorTone: "Nijansa",
        fandeckPosition: "Pozicija kolor karte",
        moreInfoIcons: "More info icons",
        notExistingFormula: "NepostojecÌa formula",
        orderBy: "Rasporedi prema",
        selectYourGrid: "Odaberite mreÅ¾u",
        showInPanel: "PrikaÅ¾i na panelu",
        warningIcon: "NepostojecÌa formula - Ikonica upozorenja"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "Use Batch numbers by percentage",
        batchNumberFromLastFilling: "Use Batch numbers from the last filling",
        defectiveBatchOfColorant: "Defective Batch of colorant",
        enableBatchNumber: "Enable colorant Batch numbers",
        possibleDamagedBatchOfColorant: "Possibly damaged Batch of colorant",
        scanOrTypeBatchNumber: "Scan or type Batch number"
    },
    colorantPanel: {
        manualMachine: "machine"
    },
    colorantsTable: {
        numberOfColorants: "Broj koloranata:",
        preview: "Pregled",
        prices: "Cene"
    },
    currencySettings: {
        addNewCurrency: "Dodaj novu valutu",
        codePlaceholder: "Å ifra recepture",
        currencySettings: "PodeÅ¡avanje valute",
        namePlaceholder: "Ime",
        ratePlaceholder: "Stopa",
        setDecimalPlaces: "Podesite broj decimala",
        setMainCurrency: "Podesite glavnu valutu",
        setRounding: "ZaokruÅ¾ite",
        symbolPlaceholder: "Simbol"
    },
    customFandecks: {
        customFandecks: "PodeÅ¡ene kolor karte",
        deleteButtonWarning: "All formulas in fandeck will be removed too.",
        deleteCustomFandeck:
            "Do you really want to delete this custom fandeck? All formulas in this fandeck will be deleted too.",
        disableStandardFandecks: "Show only custom fandecks",
        enableStandardFandecks: "Show standard fandecks",
        fandeckName: "Naziv kolor karte"
    },
    customRedlike: {
        addColorantFromBrand: "Add colorant from %{brandName} brand",
        addNewCustomer: "Dodajte novog kupca",
        addNewNote: "Dodajte novu beleÅ¡ku",
        addedDate: "Dodat datum",
        addedQuantity: "Dodata koliÄina",
        availableMachine: "MaÅ¡ina je dostupna",
        brand: "Brend",
        brandPlease: "Molimo odaberite brend",
        cancelCustomer: "OtkaÅ¾ite kupca",
        colorPlease: "Odaberite boju",
        confirmCustomerData: "Potvrdite podatke o klijentima",
        confirmNoteData: "Potvrdite podatke o napomenama",
        confirmSelectedUser: "Da li Å¾elite da koristite kupca %{customerName} za ovu porudÅ¾binu.",
        confirmed: "PotvrÄeno",
        controlData: "KonaÄna kontrola podataka",
        customerCellNumber: "Broj mobilnog telefona kupca",
        customerFilter: "Filter za kupca",
        customerName: "Ime kupca",
        customerPhone: "Broj telefona kupca",
        customerPlease: "Molimo Vas odaberite kupca",
        dateFilter: "Filter za datum",
        enterPin: "Unesite PIN Å¡ifru",
        enterTheNumberOfPackages: "Unesite broj paketa",
        existingCustomer: "Korisnik veÄ postoji",
        fandeckPlease: "Odaberite kolor kartu",
        fillCanisterHistory: "Popunite istorijat kanistera",
        findCustomer:
            "Da bi povezali ovu narudÅ¾bu sa karticom lojalnosti, molimo skenirajte barkod ili potraÅ¾ite e-mail adresu",
        findCustomerByEmail: "Filter za korisnike putem e-mail-a ili barkod",
        finishPreviousStep: "(Molimo dovrÅ¡ite prethodni korak)",
        formulaUnit: "Jedinica recepture",
        getBackToList: "Vratite se na listu kupaca",
        historyOfOrders: "Istorijat narudÅ¾bi",
        insertNote: "Idite da dodate beleÅ¡ke",
        loadHistoryOrder: "Å½elite li uÄitati odabranu porudÅ¾binu?",
        loyaltyCards: "Kartica lojalnosti",
        machineIsAvailable: "MAÅ INA JE DOSTUPNA",
        machineIsUnavailable: "MAÅ INA NIJE DOSTUPNA",
        newLoyaltyCard: "Nova kartica lojalnosti",
        noAvailableMachine: "MaÅ¡ina nije dostupna",
        noCustomerSelected: "Nije odabran nijedan kupac. Da li Å¾elite da nastavite?",
        notePlease: "Molimo unesite beleÅ¡ku",
        openHistory: "Otvorite istorijat",
        orAdd: "ili dodajte kupca",
        orSelect: "ili odaberite kupca",
        orderModification: "The original order will be modified. Do you want to continue?",
        orderOverview: "Pregled naloga",
        orderToMachine: "POÅ ALJI MOJU NARUDÅ½BU MAÅ INI",
        ordersHistory: "Istorijat naloga",
        packagePlease: "Molimo odaberite pakovanje",
        pleaseSelectBrand: "Molimo odaberite brend",
        previewImage: "IMG pregled",
        previewPackage: "Pregled pakovanja",
        productPlease: "Molimo odaberite proizvod",
        resetFilters: "Resetujte sve filtere",
        searchForHistoricalOrders: "ili potraÅ¾ite u istorijatu naloga",
        selectBrand: "Molimo daberite brend",
        selectColor: "Idite da odaberite boju",
        selectCustomer: "Idite da odaberite kupca",
        selectExistingCustomer: "Odaberite postojeÄeg kupca",
        selectFandeck: "Idite da odaberite kolor kartu",
        selectManually: "If you want to use this color in %{brandNames} brand, please select it manually.",
        selectPackage: "Idite da odaberite pakovanje",
        selectProduct: "Idite da odaberite proizvod",
        shotsCoefficient: "Shots koeficijent",
        showDetail: "PrikaÅ¾i detalje",
        showHideEshopName: "Show/Hide the eshop name of the color in a separate column",
        showKeyboard: "PrikaÅ¾i tastaturu",
        skipCustomerButton: "PreskoÄite odabir kupca",
        skipCustomerText: "PreskoÄite ako ne Å¾elite da unesete kupca",
        skipNote: "PreskoÄite beleÅ¡ku i pogledajte rezime",
        spectroBrand: "Searching in brand %{brandName}",
        statusAccepted: "prihvaÄeno",
        statusCanceled: "otkazano",
        statusCreated: "kreirano ",
        statusDone: "Gotovo",
        statusPartlyDone: "delimiÄno uraÄeno",
        statusPreparing: "priprema",
        summaryChosenBase: "baza",
        summaryChosenBrand: "brend",
        summaryChosenCanSize: "veliÄina kante",
        summaryChosenColor: "boja",
        summaryChosenColorCard: "Kolor karta",
        summaryChosenProduct: "Proizvod",
        summaryChosenQuantity: "koliÄina",
        summaryColorPreview: "Pregled boja",
        summaryCustomNote: "PrilagoÄena beleÅ¡ka",
        summaryCustomerNumber: "broj kupca",
        summaryFormula: "receptura",
        summaryFormulaNote: "Napomena o formuli ",
        summaryNote: "BeleÅ¡ka",
        sureAboutSend: "Jeste li sigurni da Å¾elite da poÅ¡aljete narudÅ¾bu?",
        useCustomerInOrder: "Å½elite da koristite %{customerName} sledec?im redosledom?",
        uuid: "UUID",
        viewSummary: "PrikaÅ¾i rezime",
        volume: "Zapremina"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "PIN - Potvrda narudÅ¾be",
        pinScreenSaverConfirmation: "PIN - Potvrda screensaver-a",
        pinSettingsConfirmation: "PIN - Potvrda podeÅ¡avanja",
        printAuto: "Dopustite automatsko Å¡tampanje",
        printerSettings: "PodeÅ¡avanje Å¡tampaÄa",
        selectColorWithFandeck: "ZajedniÄki izbor boja i kolor karte",
        setKeyboard: "Podesite tastaturu",
        setKioskMode: "Podesite funkcije kioska",
        setLanguage: "Podesite jezik",
        setModule: "Podesite modul",
        setQuickSelect: "Podesite brzo odabiranje",
        setScreensaverTimeout: "Podesite vremensko ograniÄenje screensaver-a",
        setUnit: "Podesite jedinicu"
    },
    customRedlikeMachine: {
        action: "Akcija",
        additionalPrint: "Dodatno Å¡tampanje",
        brand: "Brend",
        brandAccess: "Korisnik '%{userName}' nema pristup podacima brenda '%{brandName}'",
        can: "Kanta postavljena",
        canistersLevel: "Pregled nivoa kanistera",
        closeDetailInformation: "Zatvorite detalje",
        colorantsAmount: "KoliÄina koloranata",
        confirmRefill: "Potvrdite dopunjavanje koloranata",
        deleteOrder: "IzbriÅ¡ite nalog",
        dialogNoMachine: "MaÅ¡ina nije povezana",
        dialogNoRcc: "RCC nije povezan",
        dispense: "Doziranje",
        dispenserInErrorState: "Dispenzer ima greÅ¡ku",
        dispensingIsOk: "Dispenzer je u redu",
        emergencyButtonPressed: "PrekidaÄ za zaustavljanje u nuÅ¾di je pritisnut",
        errorCode: "Å ifra greÅ¡ke",
        errorEvents: "GreÅ¡ke dispenzera",
        errorReset: "Resetovanje greÅ¡ke",
        explanation: "ObjaÅ¡njenje",
        imageNotAvailable: "Slika nije dostupna",
        incorrectCanister: "PogreÅ¡an kanistar je skeniran!",
        incorrectColorant: "GREÅ KA: PogreÅ¡an kolorant je skeniran. Molimo Vas skenirajte ispravan kolorant",
        lastEvents: "Poslednji dogoÄaji",
        machineActions: "Senzori dispenzera",
        machineConfiguration: "Konfiguracija dispenzera",
        machineError: "GreÅ¡ka maÅ¡ine",
        machineIsBusy: "MaÅ¡ina je zauzeta",
        machineNotAvailable: "MaÅ¡ina nije dostupna",
        machineTinting: "Molimo saÄekajte, maÅ¡ina tonira...",
        manualScan: "RuÄno skeniranje",
        notEnoughSpace: "GreÅ¡ka: Ne postoji dovoljni prostor za ovaj paket koloranata",
        numberOfCanistersUnderCriticalLevel: "Broj kanistera ispod kritiÄnog nivoa je %{0}",
        numberOfCanistersUnderWarningLevel: "Broj kanistera ispod nivoa upozorenja je %{0}",
        offlinePressed: "PrekidaÄ offline je aktivan",
        orderSettings: "PodeÅ¡avanja narudÅ¾be",
        otherOrderInformation: "Detelja narudÅ¾be",
        packageCount: "Broj pakovanja",
        packageWithSeparator: "Pakovanje",
        received: "Primljeno",
        receivedOrders: "Primljene narudÅ¾be",
        receivedTime: "Primljeno vreme",
        recirculation: "Recirkulacija",
        refillInformation: "Kolorant: %{0}, Punjenje: %{1}, Kanistar: %{2}",
        resetErrors: "Resetujte greÅ¡ke",
        scanCanister: "Skenirajte ovaj kanister",
        scanColorantPackage: "Skeniraj adekvatno pakovanje koloranata",
        selectedOrder: "Odabrana narudÅ¾ba",
        shelfMovingDown: "Polica se kreÄe prema dole",
        shelfMovingUp: "Polica se kreÄe prema gore",
        solution: "ReÅ¡enje",
        startDispensing: "PoÄnite doziranje",
        stirring: "MeÅ¡anje",
        touchToStartFilling: "Dodirnite da biste zapoÄeli punjenje boje",
        unknownBrand: "Nepoznati brend"
    },
    customRedlikeSettings: {
        addPos: "POS informacije",
        addServer: "Dodajte server",
        adminOperations: "Admin operations",
        adminSettings: "Administratorska podeÅ¡avanja",
        another: "Drugo",
        aslOrService: "ASL ili servis",
        availableMachines: "Dostupne maÅ¡ine",
        barcode: "Barkod",
        basicOperations: "Osnovne operacije",
        canisterBarcodes: "Kanister barkodova",
        canisterLevels: "Nivoi kanistera",
        closeConnection: "Close connection",
        closeRedlike: "Zatvorite %{name}",
        databaseList: "Baze podataka",
        disabledStatus: "? onemoguÄen",
        dispenseLogicType: "Vrsta logiÄke distribucije",
        dropServers: "Ispustite servere",
        editServer: "Uredi server",
        lastEvent: "Poslednji dogaÄaj",
        logOut: "Odjavite se",
        machineConfiguration: "Konfiguracija",
        maxDispenseAmount: "Max koliÄina doziranja",
        offlineStatus: "? offline",
        onlineStatus: "? online",
        openFrondesk: "Otvorite prijem",
        print: "PodeÅ¡avanja Å¡tampanja",
        rebootPC: "Pokrenite ponovo raÄunar",
        restartRedlike: "Pokrenite ponovo %{name}",
        restoreConnection: "Povratite vezu",
        scanCanisterBarcode: "Skeniranje barkod kanistera",
        scanOrDeleteCanisterBarcode: "Skenirajte ili izbriÅ¡ite barkod",
        setCanisterBarcode: "Podesi barkod kanistera",
        swVersion: "Verzija softvera",
        systemFunctions: "Funkcije sistema",
        userSettings: "PodeÅ¡avanja korisnika"
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "Uredi boju",
        editColorant: "Uredi kolorant",
        emptyColorant: "Postoji kolorant sa praznom koliÄinom",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "Formula for master product",
        formulaForMasterProductWithParam: "Formula for master product %{productName}",
        isNotAvailable: "nije dostupno",
        noBaseSelected: "Baza je neophodna",
        noColorantsSelected: "Nisu odabrani koloranti",
        noFandeckSelected: "Kolor karta je neophodna",
        noNameOrCode: "Color name and code are required",
        noProductSelected: "Proizvod je neophodna",
        productPreview: "Pregled proizvoda",
        saveCustomRecipe: "SaÄuvajte prilagoÄenu recepturu",
        saveIsNotAvailable: "Äuvanje nije dostupno",
        showSiblingProducts: "Show sibling products",
        siblingProducts: "Sibling products by master product"
    },
    customersTab: {
        addCustomer: "Dodajte kupca",
        additionalSettings: "Additional Settings",
        adress: "Adresa",
        createAndSelect: "Dodajte i izaberite",
        createNewCustomer: "Kreirajte novog kupca",
        editCustomer: "Izmenite kupca",
        expiration: "Customer %{name} will expire in %{dayCount} days",
        identificationNumber: "Identification number",
        information: "Kontakt",
        listOfCustomers: "Spisak kupaca",
        rabat: "Popust",
        selectCustomer: "Izaberite kupca",
        spentLastMonth: "PotroÅ¡nja proÅ¡log meseca",
        spentMoney: "NovÄana potroÅ¡nja",
        typeOfMargin: "Vrsta margine",
        zipCode: "PoÅ¡tanski broj"
    },
    dialog: {
        cheaperColorSearch: "Cheaper color search is in progress",
        competitiveColorSearch: "Konkurentna pretraga boja je u toku",
        reallyChangeModule: "Da li zaista Å¾elite da promenite modul?",
        reallyCloseRedlike:
            "Da li stvarno Å¾elite zatvoriti %{name}? Svi %{name} paneli bicÌe zatvoreni, nesaÄuvane promene cÌe biti izgubljene.",
        reallyDeleteOrder:
            "Da li zaista Å¾elite da izbriÅ¡ete ovu porudÅ¾binu? Svi podaci povezani sa ovom porudÅ¾binom bicÌe izgubljeni.",
        reallyRebootPC:
            "Da li zaista Å¾elite da ponovo pokrenete ovaj raÄunar? Svi paneli bicÌe zatvoreni, nesaÄuvane promene cÌe biti izgubljene.",
        reallyRestartRedlike:
            "Da li stvarno Å¾elite da ponovo pokrenete %{name}? Svi paneli bicÌe zatvoreni, nesaÄuvane promene cÌe biti izgubljene.",
        reallyShutdownPc:
            "Da li zaista Å¾elite da iskljuÄite ovaj raÄunar? Svi %{name} paneli bicÌe zatvoreni, nesaÄuvane promene cÌe biti izgubljene.",
        unlockComputer: "Computer will be unlocked."
    },
    dispenseLogicTypes: {
        1: "Dozirajte samo maksimalnu koliÄinu koja moÅ¾e da se dozira",
        2: "Dopustite ruÄno doziranje pomoc?u vage za koliÄine iznad maksimalne granice doziranja",
        3: "Dopunite tokom toniranja (podelite koliÄinu na manje komade)",
        4: "Force manual dispensing using scale only in case of custom package"
    },
    editCustomFandeck: {
        fandeckName: "Naziv kolor karte"
    },
    editFormulaRgbModal: {
        apply: "Primenite",
        blue: "Plava",
        green: "Zelena",
        modalLabel: "UreÄivanje boja",
        red: "Crvena",
        tryGenerateRgb: "Try to generate RGB by colorant amounts"
    },
    environmentsSettings: {
        allowAutoCloseTab: "Close formula tab automatically",
        allowBarcodes: "Dozvolite barkodove",
        allowBuildingSitePanel: "Allow building site specification",
        allowCustomers: "Dopustite kupcima",
        allowDeleteConfirmation: "Dopustite brisanje potvrde",
        allowDiskSpaceNotification: "Allow disk space notification",
        allowDispensing: "Dopustite doziranje",
        allowFileTransfer: "Allow automatic file transfer",
        allowFormulaModificationPanel: "Allow formula modification panel",
        allowFormulaStatusPanel: "Allow formula status panel",
        allowInternalNotes: "Allow internal notes",
        allowLight: "Dopustite %{name}",
        allowOrderNotificationModal: "PrikaÅ¾i nova obaveÅ¡tenja o narudÅ¾bi",
        allowOrdering: "Dopustite naruÄivanje",
        allowPricing: "Dozvolite dodeljene cene",
        allowPrint: "Allow print",
        allowProductPreviewImage: "Dopustite pregled slike proizvoda tokom doziranja",
        allowQualityControl: "Allow quality control",
        allowSearchCheaperColors: "Allow searching for cheaper colors",
        allowSound: "Dopustite obaveÅ¡tenja o zvuÄnom nalogu",
        allowSpectro: "Dopustite spektrometar",
        allowTabs: "Allow tabs",
        applyZoom: "Primeni zumiranje",
        automaticLogout: "Automatic logout",
        barcodeScan: "Barcode Scan",
        canisterBarcode: "Barkodove kanistera",
        canisterLevel: "Nivo kanistera",
        changelog: "Promena zapisa",
        closeTab: "Zatvori kartelu",
        colorDifference: "Color difference",
        colorPanelNavItem: "Color Palette",
        competitiveColorSearch: "Konkurentna pretraga boja",
        customBanner: "PrilagoÄeni baner",
        customCurrencyFormat: "Currency format",
        customDateFormat: "Date format",
        customNumberFormat: "Number format",
        customTimeFormat: "Time format",
        deltaA: "Delta A",
        deltaB: "Delta B",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta metamerism",
        discount: "Show discount",
        dispensingHistory: "Istorijat doziranje",
        dispensingNotes: "Dopustite distribuciju beleÅ¡ki",
        enableCustomers: "OmoguÄite kupcima",
        enableDeleteConfirmation: "OmoguÄite brisanje potvrde",
        enableDispensing: "OmoguÄite distribuciju",
        enableLight: "OmoguÄite %{name}",
        enableMarginMarkup: "OmoguÄite margine ili oznaÄavanje",
        enableNotes: "OmoguÄite beleÅ¡ke",
        enableOrdering: "OmoguÄite naruÄivanje",
        enableProductPreviewImage: "OmoguÄite pregled slike proizvoda",
        enableSpectro: "OmoguÄite spektrometar",
        enableVirtualKeyboard: "Dopustite virtualnu tastaturu",
        environmentsSettings: "PodeÅ¡avanja okruÅ¾enja",
        exportTranslationKeys: "Preuzmite kljuÄeva za prevod",
        formulaNotes: "Dopustite beleÅ¡ke recepture",
        hintTooltips: "Saveti ideja",
        image: "Slika",
        keyboardShortcuts: "PreÄice tastature",
        languageBased: "Language based",
        lockYourComputer: "ZakljuÄajte raÄunar",
        machineReset: "Resetujte maÅ¡inu",
        manageTranslations: "Upravljanje prevodima",
        margin: "Samo margina",
        markup: "Samo oznaÄavanje",
        matchingRowCount: "Set number of results found",
        maxNumberTabs: "Maksimum broj kartela receptura",
        memoryTabs: "Store recently opened tabs",
        moreInfo: "Boja + slika + viÅ¡e informacija",
        navigationItems: "PodeÅ¡avanja stavki za navigaciju",
        newTab: "Nova kartela",
        numberOfPriceGroups: "Number of price groups",
        order: "NarudÅ¾ba",
        orderId: "ID narudÅ¾be",
        ordersHistory: "Istorijat narudÅ¾be",
        overwriteLastTab: "Overwrite last formula tab",
        priceCalculation: "Price calculation",
        priceDefBothPurchasePrimary: "Both, purchase primary",
        priceDefBothSellPrimary: "Both, sell primary",
        priceDefPurchaseOnly: "Purchase price only",
        priceDefSellOnly: "Sell price only",
        priceDefinition: "Price definition",
        priceGroupsEnabled: "Enable price groups",
        runLightAtStartUp: "Pokrenite %{light} pri pokretanju",
        screenSaverTimeout: "Screensaver timeout",
        selectedSpectro: "Selected %{spectro} spectro.",
        selectedSpectroNone: "No spectro selected.",
        setAutomaticClientStart: "Pokrenite %{name} pri pokretanju raÄunara",
        setCustomHomeButton: "Podesite akciju poÄetnog tastera",
        setDecimalPlaces: "Podesite broj decimalnih mesta",
        setFormulaPreview: "Podesite pregled recepture",
        setFormulaUnit: "Podesite jedinicu recepture",
        setFts: "Koristite pretragu punog teksta",
        setInfoItemInRgb: "Podesite informacije viÄene u pregledu recepture boje",
        setKeyboardShortcuts: "Podesite preÄice tastature",
        setKioskMode: "Podesite reÅ¾im kioska",
        setKioskModeOff: "IskljuÄite reÅ¾im kioska",
        setKioskModeOn: "UkljuÄite reÅ¾im kioska",
        setNavigationItems: "Podesite stavke za navigaciju",
        setNavigationItemsList: "Podesite vidljivost i redosled navigacijskih stavki",
        setOrderSearchItems: "Podesite parametre za pretragu naloga",
        setRounding: "Podesite zaokruÅ¾ivanje",
        setSearchParameters: "Podesite parametre pretraÅ¾ivanja formule",
        setTabLimit: "Podesite ograniÄenje kartele",
        setYourLanguage: "Podesite jezik",
        setZoom: "Podesite zum",
        showLocalPrices: "Show local prices",
        skipPlaceCanDialogEnabled:
            "Ovo podeÅ¡avanje se ne moÅ¾e promeniti jer je opcija poloÅ¾aj kante  deaktivirana u podeÅ¡avanjima maÅ¡ine",
        sortItems: "Sortirajte stavke za navigaciju",
        startDispensing: "PoÄnite doziranje",
        stir: "PromeÅ¡ati"
    },
    error: {
        errorDetail: "Detalji greÅ¡ke",
        errorOccurred:
            "DoÅ¡lo je do neoÄekivane greÅ¡ke. Kontaktirajte naÅ¡u podrÅ¡ku na %{0} i mi c?emo vam se obratiti u najkraÄem moguÄem roku",
        hideDetail: "Sakrij detalje"
    },
    favoritesTab: {
        addFolder: "Dodajte folder",
        closeTabToLoadFormula:
            "Molim Vas zatvorite jednu od receptura da biste otvorili novu kartelu. Dostigli ste maksimalni broj kartela",
        deleteFolder: "IzbriÅ¡ite foldera",
        editFolder: "Izmenite folder",
        favoriteFormulas: "Omiljene recepture",
        formulaNotes: "Napomene formule",
        message: {
            formulasFromFolder: "Recepture iz foldera",
            moveAllFormulas: "Premestite sve recepture iz ovog foldera u njegov matiÄni",
            removeAllFormulas: "Uklonite sve recepture iz ovog foldera",
            wantToDeleteFolder: "Da li zaista Å¾elite da izbriÅ¡ete ovaj folder?"
        },
        newFolder: "Novi folder",
        packages: "Pakovanje",
        pricePerPackage: "Cena po pakovanju",
        regularPrice: "Standardna cena",
        removeFromFavorites: "Uklonite iz omiljenih",
        specialPriceOff: "Posebna cena %{number}% popust",
        specialPriceVIP: "Posebna cena VIP"
    },
    fileTransfer: {
        afterImport: "After import",
        alreadyExists: "Task for given type and format already exists",
        customFormulaSimple: "Custom formula simple",
        direction: "Direction",
        exportTask: "File export task",
        fileTransferNotification: "File transfer notification",
        flashMessage: "Flash message",
        importTask: "File import task",
        noInformation: "No information",
        protocol: {
            folder: "Folder",
            ftp: "FTP protocol",
            ftps: "FTPS protocol",
            redlikeStorage: "%{softwareName} FTP storage protocol",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "Protocol checking files in defined local folder.",
            ftp: "Protocol checking files in remote FTP folder using standard FTP connection.",
            ftps: "Protocol checking files in remote FTPS (FTP-SSL / FTP Secure) server using standard FTP connection.",
            redlikeStorage: "Protocol checking files in %{softwareName} storage."
        },
        remoteFolder: "Remote folder",
        startType: "Start type",
        statusbar: "Statusbar information",
        testConnection: "Test connection",
        xMoreLeft: "(%{amount} more left)",
        xmlImporting: "XML file is being imported"
    },
    filtering: {
        consumptionType: "Consumption type",
        filter: "Filter",
        from: "Od",
        to: "Do"
    },
    findText: {
        findTextTitle: "Find text",
        removeMarks: "Remove marks",
        search: "Search word"
    },
    flashMessage: {
        VMNotAllowed: "Virtualna maÅ¡ina nije dostupna",
        addedToStock: "Successfully added items to stock",
        allRecordsDeleted: "All imported records were successfully deleted",
        autologinFailed: "Database autologin failed.",
        autotaskDuplicateName:
            "GreÅ¡ka integriteta baze podataka: %{0} predmet sa %{1} %{2} vec? postoji, koristite drugaÄiji %{3}",
        barcodeIsUsed: "The barcode is already used.",
        barcodeNotFound: "Barkod nije pronaÄen",
        bugReportSent: "VaÅ¡ izveÅ¡taj greÅ¡aka je uspeÅ¡no poslat",
        cannoctConnectToServer: "Nije moguÄe povezivanje sa serverom",
        cannotWriteLicense: "Licenca nije moguÄe da se napiÅ¡e",
        clientConnectionRejected: "Veza je odbijena",
        clientNotLoggedIn: "klijent nije prijavljen",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "Colorant package successfully removed from stock.",
        competitiveSearchEmpty:
            "No competitive colors could be found. Change searching parameters or select a different color.",
        competitiveSearchSelectProduct: "Please select product to start competitive color search.",
        computerBackdated: "RaÄunar je zastareo",
        connectionFailed: "Connection test failed: %{0}",
        connectionSuccess: "Connection test was successful",
        corruptedLicenseFile: "Datoteka licence je oÅ¡teÄena",
        customFormulaCreated: "Custom formula successfully created.",
        customFormulaCreationError: "Error while creating custom formula.",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "Korisnik nije pronaÄen.",
        dataNotAvailable: "Server se ne moÅ¾e povezati sa bazom podataka",
        datacolorMatching: {
            couldNotConnect: "Could not connect to Datacolor Matching, either server down or PC is offline.",
            disabled: "Datacolor Matching disabled.",
            internalError: "Datacolor Matching internal error: '%{0}'",
            invalidCredentials: "No or invalid credentials for Datacolor Matching provided, contact database provider.",
            noCansAvailable: "No cans available for selected color file (product line), contact database provider."
        },
        defaultMessage: "Tokom poslednje akcije servera doÅ¡lo je do neoÄekivane greÅ¡ke",
        deleteAll: "Izbrisati sve",
        deletingImportedData: "Deleting imported records.",
        disableWinterPlugin:
            "Zimski dodatak moÅ¾ete onemoguc?iti pomoc?u opadajuc?e liste na desnoj strani navigacije na karteli",
        duplicateBarcode: "Duplicate barcode already exists.",
        duplicateName: "Duplikat naziva veÄ postoji",
        emptyFandeck: "Selected fandeck is empty.",
        emptyStock: "There are no records in stock for the item you have used.",
        expiredLicense: "Licenca je istekla",
        exportSuccess: "Podaci su uspeÅ¡no preuzeti",
        fandeckExist: "Ovo prilagoÄeno ime kolor karte vecÌ postoji.",
        featureNotAutorized: "Funkcija nije odobrena",
        fileExportComplete: "Datoteka je uspeÅ¡no preuzeta",
        fileExportError: "An error occurred during file export.",
        fileSaveComplete: "File was successfully saved.",
        fileSaveError: "An error occurred during file saving.",
        fileTransferCustomFormulaRecordsAdded: "New custom formula records were added from the received file.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "Could not fully process custom formula data in file: '%{0}', see error log files for more info.",
        fileTransferCustomFormulaRecordsProcessed:
            "The new custom formula records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferCustomerRecordsAdded: "New customer records were added from the received file.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "Could not fully process customer data in file: '%{0}', see error log files for more info.",
        fileTransferCustomerRecordsProcessed:
            "The new customer records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferFileNotProvided: "File not provided or is empty.",
        fileTransferHistoryRecordsAdded: "New dispensing history records were added from the received file.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "Could not fully process dispensing history data in file: '%{0}', see error log files for more info.",
        fileTransferHistoryRecordsProcessed:
            "The new history records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferInvalidFile: "Could not process data in file, file is not valid.",
        fileTransferOrderRecordsAdded: "New order records were added from the received file.",
        fileTransferOrderRecordsNotFullyProcessed:
            "Could not fully process order data in file: '%{0}', see error log files for more info.",
        fileTransferOrderRecordsProcessed:
            "The new order records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferUnknownVersion: "Could not detect version of file.",
        filetransferNoData: "No database connection, check settings",
        formulaDataUnavailable: "Podatci recepture nisu dostupni",
        helperDefaultMessage: "Tokom poslednje akcije PomoÄnog Servera doÅ¡lo je do neoÄekivane greÅ¡ke",
        helperServerError: "GreÅ¡ka PomoÄnog Servera",
        importAborted: "Procedura postavljanja je prekinuta",
        importSuccess: "Podaci su uspeÅ¡no upostavljeni",
        incompatibleBaseCan: "Baza nije kompatibilna s odreÄenim proizvodom, bazom i pakovanjem",
        incorrectPassword: "VaÅ¡a stara lozinka nije ispravna. Unesite ispravnu",
        invalidCurrency: "Å ifra valute nije validna. Euro je postavljen kao zadana valuta",
        invalidDatabaseName: "Ime baze podataka nije validno",
        invalidEmail: "VaÅ¡a e-mail adresa nije validna",
        invalidFormulaColorants:
            "There is the software issue in the formula. Formula could be wrong! Contact your support!",
        invalidLicenseCompanyUserKey: "Nije validan kljuÄ kompanije-korisnika",
        invalidLicenseFile: "Nije validna datoteka licence",
        invalidLicenseIdentificationKeys: "VaÅ¡a identifikacijska dozvola licence nije validna",
        invalidLicenseKey: "VaÅ¡a licenca nije validna",
        invalidLicenseProduct: "Datoteka licence ne odgovara proizvodu",
        invalidRccResponse: "Tokom poslednjeg procesa RCC ?dziva doÅ¡lo je do neoÄekivane greÅ¡ke",
        invalidServerResponse: "Tokom poslednjeg procesa servera ?dziva doÅ¡lo je do neoÄekivane greÅ¡ke",
        invalidUrl: "URL nije validan",
        itemNotFound: "Stavka nije pronaÄena.",
        keyboardShortcutUsedInModal:
            "Ova preÄica tastature ne moÅ¾e se koristiti u pop-up prozoru. Molimo zatvorite prvo prozor",
        keyboardShortcutValidation: "Jedna preÄica tastature ne moÅ¾e se postaviti za dve razliÄite akcije",
        licenseHasBeenRevoked: "Licenca Vam je oduzeta. Da biste je obnovili, obratite se svom dobavljaÄu softvera.",
        licenseProlongationNeeded:
            "Potrebno je produÅ¾enje licence (poveÅ¾ite raÄunar na Internet da biste dobili novu licencu)",
        licenseUpToDate: "Your license is up to date. No update necessary.",
        licenseUpdateUnsuccessful: "Could not update license.",
        licenseUpdated: "License has been successfully updated.",
        licensedOnDifferentComputer: "Proizvod originalno licenciran na drugom raÄunaru",
        logFileArchiveDownloadComplete: "Preuzimanje arhiva prijave uspeÅ¡no je zavrÅ¡eno",
        loginError: "Tokom prijavljivanja doÅ¡lo je do neoÄekivane greÅ¡ke",
        logoutError: "Tokom odjavljivanja doÅ¡lo je do neoÄekivane greÅ¡ke",
        machineIsConnecting: "MaÅ¡ina je povezana, molimo saÄekajte",
        machineIsNotConnected: "VaÅ¡a maÅ¡ina NIJE SPOJENA sa RCC. Molimo proverite konfiguraciju RCC",
        malformedFormula: "Formula is malformed.",
        matching: {
            correctionNotPossible: "Correction cannot be done, use reformulation.",
            forbidden: "Request '%{0}' failed: forbidden.",
            internalServerError: "Internal server error.",
            invalidBase: "Invalid base in product.",
            invalidBipp: "Invalid base in product package.",
            invalidColorantId: "Invalid colorant with ID: %{0}.",
            invalidColorantName: "Invalid colorant with name: %{0}.",
            invalidColorfile: "Invalid color file with ID: %{0} for product with ID: %{1}.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "Invalid product with ID: %{0}.",
            invalidSpectralCurve: "Invalid spectral curve.",
            noColorfiles: "No color files defined for product with ID: %{0}.",
            notAuthorized: "Request '%{0}' failed: unauthorized.",
            notFound: "Request '%{0}' failed: not found.",
            reformulationNotPossible: "Reformulation cannot be done.",
            unknownError: "Unknown error.",
            validationError: "Request '%{0}' failed due to validation errors: %{0}."
        },
        maxFileSizeExceeded: "Maximum file size of %{0} MB exceeded",
        maxTabs: "Maksimalni broj kartela je postignut, molimo zatvorite jednu",
        noTemplate: "Å tampanje se ne moÅ¾e izvrÅ¡iti jer nisu dostupni obrasci",
        openNewTab: "Please open a new formula tab to load formula using barcode",
        orderAlreadyAcquired: "NarudÅ¾ba je vec? steÄena, prvo mora biti objavljena",
        orderCreated: "NarudÅ¾ba je uspeÅ¡no poslata",
        passwordIsNotUnique: "Nova lozinka mora se razlikovati od stare",
        printCannotBeCarriedOut: "Å tampanje se ne moÅ¾e izvrÅ¡iti jer ime Å¡tampaÄa nije validno",
        problemWithFileExport: "DoÅ¡lo je do greÅ¡ke prilikom Äuvanja datoteke prijave",
        productFileWarning: "Product file is only available online.",
        productNotLicensed: "Proizvod nije licenciran",
        rccDefaultMessage: "Tokom poslednjeg RCC akcije doÅ¡lo je do neoÄekivane greÅ¡ke",
        rccError: "RCC greÅ¡ka",
        rccNeedRestart: "Molimo pokrenite ponovo VaÅ¡ RCC",
        restoredSettings: "Settings have been restored.",
        revokedLicense: "Licenca je oduzeta",
        runningOutOfSpace: "The computer is running out of free space.",
        savedFormulaToHistory: "Receptura je uspeÅ¡no saÄuvana u istorijatu toniranja",
        savedLogArchive: "Datoteka prijave je uspeÅ¡no saÄuvana u VaÅ¡em direktorijumu ",
        scanning: "Scanning in progress",
        serverError: "GreÅ¡ka na serveru",
        setClientIdentifier: "Molimo prvo postavite svoj identifikator klijenta",
        showLess: "PrikaÅ¾i manje",
        showMore: "PrikaÅ¾i viÅ¡e",
        spectroIsDisconnecting: "Spektrometar se iskljuÄuje, molimo saÄekajte",
        spectroIsNotConnected: "Spektrometar NIJE POVEZAN trenutno. Molimo proverite RCC configuraciju",
        spectroIsNotSelected: "Spektrometar NIJE ODABRAN trenutno. Molimo proverite RCC configuraciju",
        tmcNotAvailable: "%{tmc} is not available. Please check your %{collector}.",
        tmcNotConnected: "%{tmc} is not connected. Please start your %{collector} and restart server.",
        unknownError: "Nepoznata greÅ¡ka: %{0}",
        userAlreadyLoggedIn: "VeÄ ste prijavljeni",
        versionNotAllowedByLicense: "Software version is too new and is not allowed for your license.",
        webApiConnectionError: "Nije moguÄe povezati se na Web Api server",
        webApiInternalError: "Web Api server - interna greÅ¡ka",
        webApiInvalidUser: "Web Api server - korisnik nije validan",
        webApiNoLicenseAvailable: "Web Api server - licence nisu dostupne",
        wrongDataSaved: "Wrong data was saved to XML file in the %{0} folder.",
        wrongHelpInput: "PogreÅ¡an format %{0} unosa",
        wrongRccVersion: "Molimo proverite verziju VaÅ¡eg RCC-a. VaÅ¡ klijent je kompatibilan samo sa RCC %{0}"
    },
    footer: {
        aboutApplication: "About application",
        activeUser: "Active user",
        logOut: "Odjavite se",
        machineErrors: "GreÅ¡ke ureÄaja"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "Invalid",
        solvent: "Solvent based",
        universal: "Universal",
        water: "Water based"
    },
    formulaSettings: {
        allUnits: "All units available in the database",
        allowCustomFormulas: "Dopustite prilagoÄene formule",
        allowCustomPackageSize: "Dopustite prilagoÄene veliÄine pakovanja",
        allowFormulaAutomaticNaming: "Dopustite automatsko imenovanje",
        automaticNaming: "Automatsko imenovanje recepture",
        basePanelSize: "Set size of base panel",
        bippPanelSize: "Set size of base in product package panel",
        blendColorNameAndCode: "Blend color name and color code",
        buttonBellowMoreInfo: "Show button below formula notes",
        buttonInColorantPanel: "Show button in Colorants panel",
        colorCodePrimary: "Color code as primary",
        colorPanel: "Color palette",
        colorPreviewAsImage: "Color preview as image",
        colorPreviewResizable: "Resizable color preview",
        competitiveColorSearch: "Konkurentna pretraga boja",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "PrilagoÄena receptura",
        customPackageSettingsUnitGrav: "Custom package settings gravimetric unit",
        customPackageSettingsUnitVol: "Custom package settings volumetric unit",
        customPackageSize: "PrilagoÄene veliÄine pakovanja",
        customUnits: "Choose custom units",
        dropDownCalculate: "Expand the drop down menu to the height of the window",
        editColorants: "Uredi kolorante",
        editColorantsAllowed: "Dopustite ureÄivanje koloranata",
        fandeckPanelSize: "Set size of fandeck panel",
        favoriteFormulas: "Omiljene recepture",
        formulaColorPreview: "Pregled recepture boja",
        formulaDataSettings: "PodeÅ¡avanja podataka receptura",
        formulaPanel: "Panel recepture",
        formulaPanelSize: "Set size of color panel",
        formulaSettings: "PodeÅ¡avanje recepture",
        generateColorPreview: "Generate color preview",
        gravimetricOnly: "Gravimetric units only",
        hideAlternativeFormulas: "Hide alternative formulas",
        hideFormulaProperties: "Hide formula properties",
        hideHistoricalFormulas: "Hide historical formulas",
        imagesLocal: "Use only image from local database",
        imagesOnline: "Primarily, try to open online image, if it fails, open local image",
        infoPanelResizable: "Resizable more info panel",
        numberOfColorants: "Number of shown colorants",
        orderByDistance: "Order of search results by the distance",
        productDependent: "Unit depends on the selected product",
        productFilesDialog: "Show dialog to open local file or online file",
        productFilesLocal: "Use only product files from local database",
        productFilesOnline: "Primarily, try to open online product file, if it fails, open local file",
        productPanelSize: "Set size of product panel",
        searchPanelQuickSelect: "Quick select",
        setAdditionalFormulaPanel: "Podesite dodatni panel recepture",
        setCompetitiveColorSearch: "Enable competitive color search",
        setInitialFormulaPanel: "Podesite poÄetni panel recepture",
        setMaxToleranceForCompetitiveColors: "Podesite maksimalnu toleranciju za konkurentno pretraÅ¾ivanje boja",
        setNumberOfCompetitiveColors: "Podesite broj konkurentnih boja",
        setSearchPanel: "Podesite panel za pretragu",
        setVisibilityAndOrder: "Podesite vidljivost i redosled razliÄitih podataka formule",
        setVisibleUnit: "Podesite vidljive jedinice",
        showColorPreview: "PrikaÅ¾i pregled boja",
        showInFormulaStatusPanel: "Show in formula status panel",
        showInMoreInfoPanel: "Show in formula notes",
        sorting: "Colorant panel sorting",
        useBase: "Use selection item for base",
        useBaseInProductPackage: "Use selection item for base in product package",
        useColorCode: "Use color code",
        useColorName: "Use color name",
        useFandeckGroups: "Use fandeck groups",
        useProduct: "Use selection item for product",
        useProductCode: "Use product code",
        useProductGroups: "Use product groups",
        volumetricOnly: "Volumetric units only"
    },
    general: {
        accepted: "Accepted",
        active: "Poslednja aktivnost",
        actual: "Zapravo",
        actualLevel: "Trenutno nivo",
        add: "Dodati",
        addColorant: "Dodajte kolorant",
        addColorantForPackage: "Add colorant for package",
        addFile: "Add file",
        all: "Sve",
        amount: "Iznos",
        applyNow: "Apply now",
        attachments: "Attachments",
        automaticCorrection: "Automatic correction",
        automatically: "Automatically",
        available: "Available",
        back: "Nazad",
        base: "Baza",
        baseInProductPackage: "Baza u proizvodu i u pakovanju",
        batchNumber: "Batch number",
        bottom: "Dno",
        buildingSite: "Building site",
        calculate: "Calculate",
        can: "Kanta",
        canSize: "VeliÄina kante",
        cancel: "Otkazati",
        canister: "Canister",
        canisterId: "Kanister ID",
        canisterIndex: "Canister Index",
        canisters: "Kanisteri",
        cap: "Poklopac",
        capacity: "Kapacitet",
        channels: "Kanali",
        choose: "Izaberite  ",
        city: "Grad",
        clean: "Äist",
        clear: "ObriÅ¡ite",
        client: "Klijent  ",
        close: "Zatvorite",
        closeAll: "Close all",
        collapseAll: "Collapse all",
        color: "Boja",
        colorCode: "Kod boje",
        colorFile: "Colorfile",
        colorName: "Ime boja",
        colorPreview: "Pregled boja",
        colorant: "Kolorant",
        colorantBatchNumber: "Colorant Batch number",
        colorantPackage: "Pakovanje koloranta",
        colorants: "Koloranti",
        colors: "Colors",
        company: "Kompanija",
        competitiveColor: "Competitive color",
        confirm: "Potvrdite",
        confirmDeletion: "Da li zaista Å¾elite da izbriÅ¡ite trajno ovaj predmet?",
        confirmHelpSettings: "Da li zaista Å¾elite da saÄuvate obrazac i da ostavite polja prazna?",
        connect: "Spojiti",
        continue: "Nastaviti",
        correction: "Correction",
        country: "Country",
        created: "kreirano ",
        creationDateOf: "Creation date of",
        criticalLevel: "KritiÄni nivo  ",
        currency: "Currency",
        currentBatchNumber: "Current batch number",
        currentUfiCode: "Current UFI code",
        custom: "PrilagoÄen",
        customData: "Custom data",
        customFandeck: "PrilagoÄena kolor karta",
        customFormula: "Custom formula",
        customPackage: "PrilagoÄen",
        customPackageSettings: "Custom package settings",
        customer: "Kupac",
        customerVersion: "Verzija za kupca",
        customers: "Kupci",
        database: "Baza podataka",
        date: "Datum",
        default: "Default",
        delete: "Izbrisati",
        deleteImportedData: "Delete imported records",
        delta: "Delta",
        description: "Opis",
        disconnect: "Prekid veze",
        discount: "Discount",
        discover: "Otkrijte",
        dispense: "Doziranje",
        dispensing: "Doziranje",
        doNotShowAgain: "Do not show this message again.",
        downloadingFile: "Preuzimanje datoteka",
        edit: "Uredite",
        email: "e-mail",
        enabled: "OmoguÄeno",
        error: "GreÅ¡ka",
        expandAll: "Expand all",
        exportData: "Export data",
        exportPdf: "Export PDF",
        fan: "Ventilator",
        fandeck: "Kolor karta",
        fandeckCode: "Fandeck code",
        fandeckName: "Naziv kolor karte",
        fandecks: "Fandecks",
        favorite: "Omiljeni",
        fileTransfer: "File transfer",
        filling: "Punjenje",
        fillingDate: "Filling date",
        find: "PronaÄite",
        finish: "Finish",
        finishedCorrection: "Finished correction",
        formula: "Receptura",
        formulas: "Formulas",
        frontdesk: "Frontdesk",
        getQrCode: "Dobiti R Å¡ifru",
        gravimetric: "Gravimetric",
        historical: "Historical",
        history: "Istorijat",
        hours: "Hou.",
        id: "ID",
        images: "Images",
        in: "In",
        index: "Index",
        insertBarcode: "Molimo unesite barkod",
        install: "Instalirajte",
        installed: "Instalirano",
        instructions: "Instructions",
        internalNote: "Internal note",
        interval: "Interval",
        ip: "IP adresa",
        itemNumber: "Item no.",
        itemXOfY: "Item %{x}/%{y}",
        itemsCount: "Items count",
        later: "Later",
        limit: "Limit",
        load: "Load",
        loadFormula: "Uneti recepturu",
        localVersion: "Lokalna verzija",
        machine: "MaÅ¡ina",
        manualCorrection: "Manual correction",
        manually: "Manually",
        margin: "Margina",
        markup: "OznaÄavanje",
        matching: "Matching",
        matchingFormula: "Matching formula",
        maxLevel: "Maksimum nivo",
        maxValue: "Max value",
        maximum: "Maksimum",
        mayTakeAWhile: "This may take a while",
        measured: "Measured",
        metamarism: "Metamarism",
        minimum: "Minimum",
        minutes: "Min.",
        missingItem: "Nedostaje stavka",
        missingRequiredItems: "Svi potrebni predmeti (oznaÄeni zvezdicom) moraju biti popunjeni",
        modified: "Modified",
        modifiedAutomaticCorrection: "Target color correction",
        modifiedCustomFormula: "Modified custom formula",
        modifiedStandardFormula: "Modified standard formula",
        moduleChange: "Module change",
        more: "ViÅ¡e",
        moreInfo: "ViÅ¡e informacija",
        moveDown: "Pomerati prema dole",
        moveUp: "Pomerati prema gore",
        myOrders: "Moje narudÅ¾be",
        name: "Naziv",
        nameTitle: "Naziv",
        new: "Novi  ",
        next: "SledeÄi",
        no: "Ne ",
        noColorantsAvailable: "Nema dostupnih boja",
        noFormulas: "JoÅ¡ nema formula",
        noPricesAvailable: "Nema raspoloÅ¾ivih cena",
        nominalAmount: "Nominalni iznos",
        notAvailable: "Nije dostupno",
        note: "BeleÅ¡ka",
        numberOfCanisters: "Broj kanistera",
        numberOfItemCount: "Number of '%{item}': %{count}",
        numberOfLabels: "Broj etiketa",
        numberOfPackages: "Broj pakovanja",
        off: "IskljuÄeno",
        ok: "U redu",
        on: "UkljuÄeno",
        onFocus: "On focus",
        open: "Otvoreno",
        operator: "Operator",
        options: "Opcije",
        order: "Order",
        other: "Drugo",
        otherError: "Ostale greÅ¡ke",
        out: "Out",
        overwrite: "Overwrite",
        package: "Pakovanje",
        packagePreview: "pregled pakovanja",
        partialUpdates: "Partial updates",
        phone: "Telefon",
        pleaseWait: "Please wait",
        previous: "Previous",
        price: "Cena",
        priceGroup: "Price group",
        print: "Å tampanje",
        printTask: "Print task",
        processingStep: "Processing %{step}",
        product: "Proizvod",
        productCode: "Product code",
        productName: "Product name",
        products: "Proizvodi",
        pump1: "Pumpa 1",
        pump2: "Pumpa 2",
        purchasePrice: "Purchase price",
        purge: "ÄiÅ¡Äenje",
        qualityControl: "Quality control",
        quantity: "KoliÄina",
        quantityQty: "QTY",
        quickTint: "Brzo nijansiranje",
        rccIsNotAvailable: "RCC nije dostupan",
        rccIsNotConnected: "RCC nije spojen",
        rccNotLicensed: "RCC nije licencirano",
        reconnect: "Povezati ponovo",
        refill: "Dopuniti",
        refillManualLevelCorrection: "Manual correction",
        reformulation: "Reformulation",
        reloadTab: "Reload Tab",
        reset: "Resetovanje  ",
        restart: "Ponovo pokrenuti",
        restore: "Restore",
        retint: "Retint",
        revision: "Revizija",
        safetySheet: "Safety sheet",
        save: "SaÄuvati",
        saveAs: "SaÄuvati kao",
        saveToDispensingHistory: "SaÄuvati u istorijatu",
        searchResult: "Search result",
        searching: "Searching",
        seconds: "Sec.",
        select: "Select",
        selectAll: "Odaberi sve",
        selectChannels: "Izaberite kanale",
        selectColumns: "Select columns to work with",
        selectXFirst: "Select %{item} first",
        sellPrice: "Sell price",
        settings: "PodeÅ¡avanje",
        shelf: "Polica",
        showItem: "Show %{item}",
        showOptions: "Show another options",
        size: "Size",
        skip: "PreskoÄi",
        smartPurge: "Smart purge",
        softwareRestartInSeconds: "%{software} will be automatically restarted in %{seconds} seconds",
        sortResults: "Sort results",
        spectro: "Spektrometar",
        standardFormula: "Standard formula",
        status: "Status",
        street: "Ulica",
        sum: "Sum",
        summary: "Rezime",
        sync: "Sinhronizovati",
        technicalSheet: "Technical sheet",
        templates: "Å abloni",
        threshold: "Threshold",
        ticketing: "Ticketing",
        tintometricSystem: "Tintometric system",
        toDispenseOrders: "Za doziranje",
        top: "Vrh",
        total: "Ukupno",
        totalAmount: "Total amount",
        totalBaseAmount: "Total base amount",
        totalColorantAmount: "Total colorants amount",
        type: "Type",
        ufiCode: "UFI code",
        ufiThreshold: "UFI threshold",
        unableToSynchronize: "Unable to synchronize",
        undefined: "Undefined",
        unit: "Unit",
        units: "Jedinice",
        unknown: "Unknown",
        update: "AÅ¾uriranje",
        updated: "AÅ¾urirano",
        user: "Korisnik  ",
        value: "Value",
        vat: "PDV",
        verified: "Verified",
        version: "Verzija",
        versionId: "Verzija ID",
        versionStructure: "Struktura verzije",
        volumetric: "Volumetric",
        warning: "Upozorenje",
        warningLevel: "Nivo upozorenja",
        withoutName: "(without name)",
        workingProperly: "Working properly",
        yes: "Da",
        zoom: "Zumirajte"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the brush container automatically at the defined time. The dispenser operator needs to remove, clean, and then return the brush container manually.",
            capMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the cap automatically at the defined time. The dispenser operator needs to clean the autocap manually after it opens.",
            cleanAll:
                "Set this autotask to have the dispenser perform the action for cleaning all channels automatically at the defined time.",
            cleanChannels:
                "Set this autotask to have the dispenser perform the action for cleaning specific channels automatically at the defined time.",
            computerReboot: "Set this autotask to have the computer rebooted automatically at the define time.",
            computerShutdown: "Set this autotask to have the computer turned off automatically at the define time.",
            dispenserCleaning:
                "Set this autotask to have %{name} request the action for cleaning the dispenser automatically at the defined time. The dispenser operator needs to clean the machine with a cloth manually.",
            humidifierWaterLevelMaintenance:
                "Set this autotask to have %{name} request the action for refilling the humidifier automatically at the defined time. The dispenser operator needs to check and refill the water in the humidifier manually.",
            purgeAll:
                "Set this autotask to have the dispenser perform the action for purging all channels automatically at the defined time.",
            purgeChannels:
                "Set this autotask to have the dispenser perform the action for purging specific channels automatically at the defined time.",
            recirculateAll:
                "Set this autotask to have the dispenser perform the action for recirculating all channels automatically at the defined time.",
            recirculateChannels:
                "Set this autotask to have the dispenser perform the action for recirculating specific channels automatically at the defined time.",
            refillAll:
                "Set this autotask to have %{name} request the action for refilling all channels automatically at the defined time. The dispenser operator needs to refill colorants into all canisters manually.",
            refillCanisters:
                "Set this autotask to have %{name} request the action for refilling specific channels automatically at the defined time. The dispenser operator needs to manually refill colorants into canisters which do not meet the refill criterion.",
            smartPurgeAll:
                "Set this autotask to have the dispenser perform the action for smart purging all channels automatically at the defined time. Purge will be carried out unless the Smart purge rules are met.",
            smartPurgeChannels:
                "Set this autotask to have the dispenser perform the action for smart purging specific channels automatically at the defined time. Purge will be carried out unless the Smart purge rules are met.",
            stirAll:
                "Set this autotask to have the dispenser perform request the action for stirring all channels automatically at the defined time.",
            stirCanisters:
                "Set this autotask to have the dispenser perform request the action for stirring specific channels automatically at the defined time.",
            switchPlateMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the switch plate automatically at the defined time. The dispenser operator needs to remove, clean, and then return the switch plate manually."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "The Batch number which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            batchNumberFromLastFilling:
                "The Batch from the last refill given by the operator is used for printing regardless the refilled amount.",
            enableBatchNumber: "With this setting on, refilled colorant batches are tracked."
        },
        connection: {
            add: "Allows to add a new server manually if it could not be detected via the Discover function.",
            clientIdentifier:
                "The setting enables to identify this client if there are more clients connected to one server.",
            disconnect:
                "Information about the currently used server. The disconnect button allows to leave this server and switch to another one if available.",
            discover: "Discovers whether there are any other servers available in the network.",
            dropServers: "Deletes all previously detected servers from the list.",
            dropServersNotAvailable: "No server available",
            edit: "Allows to manually edit an already found server.",
            editDisabled: "No server selected."
        },
        continue: "Do you really want to continue?",
        driverSettings: {
            alfaRestApi: {
                host: "Unesite ime raÄunara ili IP adresu raÄunara",
                machineType: "Dostupno za sve Alfa maÅ¡ine. Windows i Linux."
            },
            corobDsProxy: {
                machineType:
                    "Dostupno za generacije Slave (D200, D600 ..), 4G (First One) i 5G (EvoFlx). DspProxy mora biti instaliran. Samo za Windows."
            },
            corobEvoDriver: {
                machineType: "Dostupno za generaciju 5G (EvoFlx). EVOservice mora biti instaliran. Windows i Linux."
            },
            corobFlex500LLD: {
                dispenserConfigurationFile: "Izaberite konfiguracionu datoteku dispenzera. Unapred zadano",
                hldRootDir: "Izaberite glavnu mapu HLD. Unapred zadano",
                machineType:
                    "Valid for Corob Flex (500, 520, 540) = former Lenteq. HLD must be installed. Windows only."
            },
            corobNextDriver: {
                machineType:
                    "Dostupno za generacije Slave (D200, D600 ..), 4G (First One) i 5G (EvoFlx). NextDriver mora biti instaliran. Samo za Linux."
            },
            dromontDDrv: {
                databasePath: "Put do datoteke baze podataka sa podacima o kalibraciji. Unapred zadano.",
                driverPath: "Put do drajvera (D_DRV.exe). Unapred zadano.",
                machineType:
                    "Indirektna komunikacija dispenzera putem zadatih putanja. Dostupno generacije V1 i V2. D_SET mora biti instaliran. Windows i Linux.",
                resultPath: "Put do rezultirajucÌe datoteke stvoren nakon zavrÅ¡etka rada. Unapred zadano.",
                serviceSoftwarePath: "Put do servisnog softvera Dromont (D_SET.exe). Unapred zadano."
            },
            dromontDirect: {
                machineType:
                    "Direktna komunikacija dispenzera. Dostupno za generacije V1 i V2. D_SET mora biti instaliran. Windows i Linux.",
                rootDir: "Izaberite glavnu Dromont fasciklu"
            },
            dromontMisura: {
                driverPath:
                    "Put do upravljaÄkog programa (MisuraRetail.exe) moÅ¾e se promeniti na osnovu Misura Retail verzije. Unapred zadano.",
                extensionPath: "Put do komunikacijske datoteke za servisne akcije.",
                formulaPath: "Put do komunikacijske datoteke za doziranja",
                machineType: "Dostupno za generaciju V3. Dromont Misura mora biti instaliran. Samo za Windows."
            },
            fastAndFluidIDD: {
                machineType: "Dostupno za sve F&F maÅ¡ine. Samo za Windows.",
                path: "PodrÅ¾ani su IDD2 (HA 450, HA 650, X-smart itd.) - moraju biti licencirani, IDD3 (HP 500, itd.), IDD4 (HA 180, HA 480, HA 680, Xprotint, itd.)"
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "Dostupno za sve F&F maÅ¡ine. Windows i Linux.",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "Dostupno za sve Hero maÅ¡ine. Samo za Windows."
            },
            italtinto: {
                machineType:
                    "Dostupno za sve Italtinto maÅ¡ine. Wcal ili ItaltintoCal mora biti instaliran. Samo za Windows.",
                path: "Put do podeÅ¡ene konfiguracione datoteke Italtinto."
            },
            manualAdvanced: {
                machineType: "Dostupno za sve ruÄne maÅ¡ine, ukljuÄena je i podrÅ¡ka za kanistere. Windows i Linux.",
                path: "Put do konfiguracione datoteke sa podacima o dispenzeru i kanistrima."
            },
            manualSimple: {
                machineType: "Dostupno za sve ruÄne maÅ¡ine. Windows i Linux.",
                path: "Put do konfiguracione datoteke sa podacima o dispenzeru."
            },
            none: {
                machineType: "No dispenser driver is selected."
            },
            santintColorLink3: {
                machineType: "Dostupno za Santint maÅ¡ine. Windows i Linux."
            },
            simulation: {
                machineType: "Dostupno za simulaciju dispenzera ukoliko ne postoji pravi dispenzer spojen na raÄunar.",
                path: "Put do konfiguracijske datoteke simulacije koja mora biti u skladu s umetnutom bazom podataka."
            },
            udcp: {
                machineType: "UDCP dispenser"
            }
        },
        environment: {
            activeServerPlugins: "The overview of additional software plugins.",
            allowAutoCloseTab:
                "With the setting on, each formula tab will be closed automatically after the dispensing process has been finished.",
            allowAutomaticClientStart:
                "Kada je ovo podeÅ¡avanje ukljuÄeno, %{name} c?e se automatski pokrenuti nakon pokretanja raÄunara.",
            allowAutomaticPrint:
                "Etiketa c?e se automatski odÅ¡tampati. Zahteva dodatno podeÅ¡avanje Å¡tampanja pre doziranja, posle doziranja ili oboje.",
            allowBuildingSitePanel: "On Formula Panel, building site panel will be available.",
            allowCustomers: "Na panelu Receptura, sekcija kupaca c?e biti dostupna.",
            allowDispensing:
                "Na panelu Receptura, taster doziranja Äe se aktiviratizajedno sa opcijama doziranja u podeÅ¡avanjima maÅ¡ine.",
            allowFileTransfer: "With this setting on, automatic data import and export by file transfer is available.",
            allowFormulaModificationPanel: "On Formula Panel, Modification panel will be activated.",
            allowFormulaStatusPanel: "On Formula Panel, Status panel will be activated.",
            allowLight: "%{name} c?e biti dostupan.",
            allowOrdering: "Na panelu recepture aktivirac?e se taster NaruÄi.",
            allowPricing:
                "Na panelu Formule, cene se mogu koristiti. Vidljivost cena je postavljena u RaspoloÅ¾ivim Cenama. Cene su postavljene u PodeÅ¡avanjima Cena.",
            allowProductPreviewImage: "Slika proizvoda c?e biti prikazana tokom doziranja.",
            allowQualityControl: "Quality control will be activated.",
            allowSearchCheaperColors: "On Formula Panel, the function to search for cheaper colors will be available.",
            allowSoundNotification:
                "ObaveÅ¡tenje o zvuÄnom nalogu reprodukuje muziÄku melodiju kada je narudÅ¾ba primljena. ",
            allowSpectro: "Sekcija spektrometra Äe biti dostupan. ",
            allowTabs: "With this setting on, working with multiple tabs simultaneously is available.",
            applyZoom:
                "Zumiranje povec?ava ili smanjuje rezoluciju. PreÄice na tastaturi CTRL + i  CTRL - takoÄe su primenljive.",
            automaticLogout: "Set after how many minutes the automatic logout should be activated.",
            availableDatabases:
                "PodeÅ¡avanja omogucÌavaju prebacivanje izmeÄu baza podataka ako je na raspolaganju viÅ¡e od jedne.",
            backupLocalDB: "Exports the local databse. The exported file can be used as database backup.",
            barcodeTesting:
                "Okolina za testiranje barkoda sluÅ¾i za proveru ispravnosti skeniranog barkoda uporeÄujucÌi ga sa barkodovima koji su ubaÄeni u bazu podataka.",
            customBanner: "Podesite svoj logo ili baner i njegov poloÅ¾aj.",
            customCurrencyFormat:
                "Custom currency format can override default currency format based on selected language. ",
            customDateFormat: "Custom date format can override default date format based on selected language.",
            customNumberFormat: "Custom numer format can override default numer format based on selected language.",
            customTimeFormat: "Custom time format can override default time format based on selected language.",
            defaultPrinter:
                "Izabrani Å¡tampaÄ koristic?e se prilikom Å¡tampanja etiketa osim ako se ne promeni u prozoru opcija Å¡tampaÄa.",
            defaultTemplate:
                "Odabrani Å¡ablon Äe se koristiti pri Å¡tampanju etiketa osim ako se ne promeni u prozoru prozoru opcija Å¡tampaÄa.",
            deleteImportedData:
                "BriÅ¡e prethodno uvezene prilagoÄene podatke. Podaci se mogu ponovo uvesti nakon brisanja.",
            diskSpaceNotification: "Checks the available disk space and notifies in case of insufficient space.",
            dispensingNotes: "Na panelu Receptura bic?e dostupna sekcija sa napomenama o doziranju.",
            downloadListEmpty: "No downloads in progress",
            enableVirtualKeyboard: "U %{name} bic?e dostupna virtuelna tastatura.",
            exportLocalSettings: "Exports the local settings of this computer.",
            exportStaticSql:
                "Exports the local settings of this computer. The exported file can be used to create a database with this setup.",
            exportTranslationKeys:
                "Export the newest translations and after translating, send them by email to your software supplier to have them imported.",
            favoriteButton: "Click to add the formula as favorite",
            formulaNotes: "Na panelu Receptura, bic?e dostupna sekcija sa napomenama recepture.",
            helpSettings: "Informacije su vidljive u sekciji Pomoc? na panelu za brzi pristup.",
            importCustomData: "Unesite lokalne prilagoÄene podatke na osnovu odabranog formata.",
            importExcelFile: "Import the excel file with data to be added to database.",
            importsLocalSettings: "Imports the local settings of this computer.",
            internalNote: "On Formula panel, internal note section will be accessible.",
            lockComputer:
                "PodeÅ¡avanja obezbeÄuju da se okruÅ¾enje od %{name} ne moÅ¾e ostaviti - omogucÌava ultimate kiosk mode iskustvo. Primenljivo samo za Windows.",
            maxNumberTabs: "OgraniÄenje kartice odreÄuje koliko se kartica kartica moÅ¾e istovremeno otvoriti.",
            memoryTabs: "Allow reopening of recently opened tabs after the software starts.",
            printAfterDispensing:
                "Ovo podeÅ¡avanje zahteva informacije o tome koliko kopija etiketa treba da se odÅ¡tampa posle postupka doziranaj.",
            printAsImage:
                "Å tampanje kao slike pomaÅ¾e u reÅ¡avanju problema kada ne uspe standardni naÄin Å¡tampanja. Ne koristite ga kada standardno Å¡tampanje radi ispravno. Kompatibilan je samo sa Linux-om.",
            printBeforeDispensing:
                "Ovo podeÅ¡avanje zahteva informacije o tome koliko kopija etiketa treba da se odÅ¡tampa pre postupka doziranja.",
            printEnabled:
                "This setting enables using printer with the software. Additional settings are in Print Settings.",
            printOnRequest: "Na panelu recepture aktivirac?e se taster Å tampanje.",
            printTaskVariable: "The print task is processed only if given print variable is available in print data",
            quickTintTemplate: "Izabrani Å¡ablon c?e se koristiti pri Å¡tampanju etiketa za brzo nijansiranje.",
            restoreLocalSettings: "Restores the local settings of this computer.",
            runLightAtStartUp: "%{light} c?e se pokrenuti umesto %{name}.",
            screenSaverTimeout: "Set after how many minutes, the screensaver should be activated.",
            selectCustomDataFormat:
                "Odaberite format originalnih podataka za unos. Svaki format moÅ¾e zahtevati razliÄite dodatne datoteke i podeÅ¡avanja.",
            setCustomHomeButton: "PoÄetni taster u %{name} preusmeric?e se na izabrani panel.",
            setFts: "PretraÅ¾ivanje punog teksta omogucÌava pretraÅ¾ivanje formula u celom tekstu (takoÄe iz sredine reÄi, itd.).",
            setKeyboardShortcuts: "Nije moguc?e podesiti istu preÄicu na tastaturi za dve razliÄite akcije.",
            setNumberOfDecimalPlaces:
                "ZaokruÅ¾ivanje postavki koliko c?e decimalnih mesta koloranata koriÅ¡tenih u recepturi biti prikazano.",
            setOrderSearchParameters:
                "PretraÅ¾ivanje narudÅ¾bi definiÅ¡e koji se parametri se koriste pri pretraÅ¾ivanju meÄu narudÅ¾bama. Dostupno samo u %{name}.",
            setOverwriteLastTab:
                "When choosing a new formula via global search whereas formula tab limit is reached, the last loaded formula tab will be overwritten by the new formula selection.",
            setSearchPanel:
                "Podesite sopstvenu vidljivost i redosled predmeta koji se koriste pri traÅ¾enju nove formule.",
            setVisibilityAndOrder:
                "Odabrane stavke za navigaciju bic?e vidljive na panelu za brzi pristup. NajviÅ¡i poloÅ¾aj ovde definiÅ¡e krajnji levi poloÅ¾aj na panelu. Maksimalna dozvoljena koliÄina navigacijskih stavki je 6.",
            setYourLanguage: "Za promenu jezika potrebno je ponovno pokretanje softvera.",
            settingsSearch: "Look up various settings if you are unsure where to find them.",
            showNewOrderNotifications:
                "ObaveÅ¡tenje o narudÅ¾bi je pop-up prozor koji objavljuje da je primljena nova narudÅ¾ba.",
            sorting:
                "Brzo nijansiranje mogu imati kanisteri naruÄeni prema imenima koloranata ili prema ID kolaranata.",
            turnOnKioskMode: "ReÅ¾im kioska sakriva taskbar.",
            windowClosingRules:
                "PodeÅ¡avanje odluÄuje da li c?e se prozor brzog nijansiranja biti zatvoren pre ili posle poÄetka postupka doziranja."
        },
        formulaSettings: {
            additionalFormulaTab: "The setting decides which panel will be shown when opening a new formula tab.",
            allowCustomFormulas: "Kreiranje i pretraÅ¾ivanje prilagoÄenih receptura c?e biti aktivirano.",
            allowCustomPackageSize: "Na panelu Receptura, prilagoÄena veliÄina pakovanja Äe biti aktivirana.",
            allowEditingColorants:
                "Na panelu recepture, aktivirac?e se taster Uredi boju (vidljivo nakon odabira boje).",
            alternativeFormulasPosition: "Defines how to access alternative formulas.",
            basePanelSize: "Set size of base on Formula panel",
            bippPanelSize: "Set size of base in product package on Formula panel",
            blendColorNameAndCode:
                "The setting joins together the search fields for Color name and code to create one search field only.",
            color: "Na panelu Receptura pregled boja c?e biti jedina vidljiva informacija.",
            colorCodePrimary: "Color code will be displayed first in the search field.",
            colorPreviewAsImage: "On Formula panel, the color preview will be represented by image.",
            colorPreviewResizable: "Allows to resize color preview panel.",
            colorantPanelLimit:
                "The settings sets the number of colorants that will be always visible before it hides under scroll bar.",
            colorantPanelOrderBy: "Formula panel can have the colorants ordered according to the names or by amounts.",
            customCanOption: "Choose which measurement units can be used for custom package size on Formula panel.",
            customCanSettingsUnit:
                "Choose which measurement unit can be used as default for custom package settings on Formula panel.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation: "OmoguÄavanjem ovog podeÅ¡avanja, pojaviÄe sepop-up prozori za potvrdu brisanja stavke.",
            dropDownCalculate:
                "The drop-down menu to select the formula you are looking for will extend to the bottom of the window.",
            fandeckGroups: "The setting enables hierarchy with fandeck groups if available in the database.",
            fandeckPanelSize: "Set size of fandeck on Formula panel",
            favoriteFormulasInitial: "Kada pokrec?ete %{name}, pojavic?e se panel Omiljeni.",
            formulaAutomaticNaming:
                "Izmenjena formula c?e se imenovati automatski na osnovu izvrÅ¡enih modifikacija boje.",
            formulaPanel: "Kada otvorite novu kartelu, pojavic?e se panel recepture.",
            formulaPanelInitial: "Kada pokrenete %{name}, pojavic?e se panel recepture.",
            formulaPanelSize: "Set size of color on Formula panel",
            formulaPropertiesPosition: "Defines how to access formula properties.",
            generateColorPreview:
                "With this setting on, the color preview will be generated automatically. The resulting preview is not accurate.",
            historicalFormulasPosition: "Defines how to access historical formulas.",
            image: "Na panelu recepture, slika proizvoda c?e biti vidljiva pored pregleda boja s moguc?noÅ¡c?u otvaranja panela sa viÅ¡e informacija.",
            images: "The setting defines the source of image files.",
            infoPanelResizable: "Allows to resize more info panel.",
            initialFormulaTab: "The setting decides which panel will be shown after %{0} starts.",
            moreInfo:
                "Na panelu Receptura, informativni panel bic?e vidljiv pored pregleda boja i pregleda slike proizvoda.",
            orderByDistance: "With this setting on, the result of color search is ordered by special distance metric.",
            productCode:
                "The setting enables to use product codes along with product names if available in the database.",
            productFiles: "The setting defines the source of product files which are available on Formula panel.",
            productGroups: "The setting enables hierarchy with product groups if available in the database.",
            productPanelSize: "Set size of product on Formula panel",
            searchNewFormula:
                "Kada otvorite novu kartelu, pojavic?e se pretraga za novu recepturu (sadrÅ¾i informacije o poslednjim doziranjima receptura i  i omiljenim recepturama).",
            searchNewFormulaInitial:
                "Prilikom pokretanja %{name}, pojavic?e se pretraga nove recepture (sadrÅ¾i informacije o poslednjim doziranjima receptura i  i omiljenim recepturama).",
            searchPanelFormulaItems: "At least one of the formula items must be selected.",
            searchPanelProductItems: "Only one of the product items can be selected.",
            searchPanelQuickSelect:
                "No need to press the load formula button. You will be redirected directly to main formula tab just after formula selection.",
            setCompetitiveColorSearch:
                "With this setting on, the feature of competitive color search in Color Palette and Formula panel (only for not available formulas) is available.",
            setFormulaInfoInPreview:
                "On Formula panel, the selected data type will be always visible in the color preview.",
            setFormulaPreview:
                "The setting changes the position and display of color preview, package image and info data about the color.",
            setFormulaRGBPreviewVisibleInformation:
                "Na panelu Receptura, izabrani tip podataka uvek c?e biti vidljiv u pregledu boja.",
            setFormulaUnit:
                "Na panelu Receptura, ovo podeÅ¡avanje odreÄuje koja c?e se boja otvoriti kao prva nakon odabira boje. TakoÄe dostupno u Brzom Nijansiranju.",
            setFormulaVisibilityAndOrder:
                "Na panelu Receptura, izabrani podaci c?e biti vidljivi u odeljku ViÅ¡e informacija (primenljivo samo ako je Postavka pregleda recepture u PodeÅ¡avanju recepture Slika ili ViÅ¡e informacija.",
            setMaxToleranceForCompetitiveColors:
                "Set the maximal Delta E (CIA 2000) tolerance for competitive color search.",
            setNumberOfCompetitiveColors:
                "Define how many competitive master colors should be offered after search. The defined number does not correspond to the number of results.",
            setVisibleUnit:
                "Na panelu Receptura, ovo podeÅ¡avanje odluÄuje koje c?e boje biti vidljive nakon izbora boje. TakoÄe se primenjuje u Brzom Nijansiranju.",
            showColorPreview:
                "Na panelu Receptura, prikazuje se mali pregled boje pored naziva boje kada traÅ¾ite novu recepturu.",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "On Formula panel, shows the information about color code."
        },
        formulaValidation: {
            batchNumberInvalid: "Canister (%{colorants}) is filled with a defective batch of colorant.",
            batchNumberWarning: "Colorant (%{colorants}) with this batch number may be damaged.",
            bellowBaseLimit: "Sum of colorant amounts is below base limit.",
            checkColorantBaseRules: "The setting checks if used colorants and base can be used in this combination.",
            checkMinDosableAmount:
                "The minimal tintable amount is the smallest colorant amount which can be dispensed as recommended by the laboratory.",
            checkOverfill:
                "The setting checks if there is enough space in the can for the colorants immediately after the amounts are set.",
            checkTotalCntAmounts:
                "The setting checks if the limits for the minimal and maximal colorant amounts in product base package have been exceeted. These limits are defined in the database.",
            colorantBaseRules: "Colorant is not valid for selected base.",
            colorantMinAmount: "Colorant amount is below the minimal tintable amount.",
            dispensingWithErrorsEnabled:
                "If allowed, a warning message will appear in case of validation violations, but it will be possible to proceed to dispensing nonetheless.",
            invalidBatchNumber: "Colorant has invalid or defective batch number",
            overBaseLimit: "Sum of colorant amounts is over maximal tintable amount.",
            overfill: "Overfill has been detected.",
            unifyColorantBatchForMultipleCans:
                "If allowed, an info refill to max modal will appear when amount of colorant is bigger than maximum of canister and canister is not filled on maximum level.",
            warningConfirmBtn: "I know the risks, continue"
        },
        help: "PomoÄ",
        helpLink: "Centar pomoÄi",
        helper: {
            automaticallyCheckForUpdates:
                "Automatski cÌe se proveriti da li postoji dostupno aÅ¾uriranje za %{name} ili bazu podataka u datom vremenskom intervalu.",
            automaticallyDownloadUpdates:
                "Ako je dostupno aÅ¾uriranje, ono cÌe se automatski preuzimati bez potrebe za potvrdom.",
            automaticallyInstallNewDatabases:
                "Ako se poÅ¡alje dosad odsutna baza podataka, biÄe instalirana kao nova baza podataka. Nakon toga baza podataka se moÅ¾e koristiti.",
            automaticallyInstallUpdates:
                "Ako je preuzimanje aÅ¾urirano, ono cÌe se automatski instalirati bez potrebe za potvrdom.",
            canBrowseChangeLog:
                "Prilikom aÅ¾uriranja softvera, zvaniÄne %{name} prijave promena cÌe biti dostupne za pregled.",
            forceInstall: "The update will be installed by force.",
            installDuringNight: "AÅ¾uriranje cÌe biti instalirano tokom nocÌi ako raÄunar bude ukljuÄen."
        },
        licensing: {
            collect:
                "The logfiles will be downloaded to the selected location. The logfiles are required by the software supplied for bug analysis.",
            company: "The company which supplied the license.",
            computerID: "License identification to help the software supplier in case of required assistance.",
            email: "The email address of the license holder.",
            licenseUuid: "License identification to help the software supplier in case of required assistance.",
            name: "The name of the license holder.",
            openBugreport:
                "Please let us know if there is a bug in the software and send us a report with the bug description.",
            posInfoContactperson: "POS information about the owner to be printed on the label.",
            posInfoMachineInformation:
                "POS information about the dispenser to be printed on the label or recognized in the network.",
            posInfoPos: "POS information about the location to be printed on the label.",
            reactivation: "Reactivation or change of the current license.",
            refresh: "Downloads the newest license information.",
            refreshUnavailable: "License refresh unavailable because you are offline.",
            registrationContactperson: "Registration information to identify the owner of the license.",
            registrationMachineInformation: "Registration information to identify the dispenser of the license.",
            registrationPos: "Registration information to identify the location of the license.",
            versionScope: "The software expiration limits.",
            versionType: "The software product type."
        },
        machineIsBusy: "GreÅ¡ke se ne mogu resetovati dokle god je maÅ¡ina zauzeta.",
        machineSettings: {
            allowManualColorantAddition:
                "Ako potrebna koliÄina koloranta prevazilazi maksimalnu koliÄinu doziranja, podeÅ¡avanje omoguc?ava da se ruÄno doda nakon doziranja.",
            autotasks:
                "Automatizacije su dogaÄaji za odrÅ¾avanje automatskih maÅ¡ina i raÄunara koji se mogu podesiti tako da se izvode u odreÄenom vremenu ili vremenskom intervalu.",
            barcodeRefillValidation: "The setting turns on barcode validation on refill.",
            barcodeRefillValidationBaseAndColorant:
                "Barcode check is performed on canister and colorant package refilling.",
            barcodeRefillValidationColorant: "Barcode check is performed on colorant package refilling.",
            canisterBarcode:
                "The barcode is assigned to the canister in which the colorant is available. The barcode is necessary to ensure correct colorant refilling.",
            checkCanBeforeDispense:
                "Konfiguracija maÅ¡ine c?e se uporeÄivati sa bazom podataka svaki put kada se RCC ponovo pokrene. U sluÄaju neusklaÄenosti pojavljuje se obaveÅ¡tenje.",
            checkOverfill: "PodeÅ¡avanje proverava da li postoji dovoljno mesta u kanti za kolorante pre doziranja.",
            currentlySelectedMachine: "Provides information about the currently selected machine.",
            dispenseInvalidColorants:
                "PodeÅ¡avanje omogucÌava doziranje koloranata koja nisu definisani u konfiguraciji maÅ¡ine poticanjem ruÄnog dodavanja koloranata",
            dispenserConfigurationBackup: "Download and save the current machine configuration to maintain a backup.",
            dispensingLogic:
                "Dispensing logic types can ensure different behaviour for each canisters when there is more colorant to be dispensed than allowed or desired. Additional behavior is set in Dispensing Settings.",
            enableTmc: "Ovo podeÅ¡avanje omoguc?ava slanje podataka u TMC.",
            enableUserIdentification: "User has to log in before dispensing is allowed.",
            machineUnit: "Jedinica maÅ¡ine definiÅ¡e jedinicu za merenje koloranata u kanistrima.",
            minDispensedAmount:
                "Min. dozirana koliÄina odreÄuje koliko koloranta treba da bude dozirano da bi se smatralo da je ÄiÅ¡c?enje izvrÅ¡eno (da bi se izbeglo dodatno ÄiÅ¡c?enje).",
            minimalDispenseAmount:
                "Minimalna dozirana koliÄina je najmanja preporuÄena koliÄina koloranta koja moÅ¾e da se dozira. Ako se prekrÅ¡i, pojavic?e se poruka (doziranje je i dalje moguc?e)",
            missingAutotaskCanisters: "Mora biti izabran najmanje 1 kanister",
            missingAutotaskChannels: "Mora biti izabran najmanje 1 kanal",
            missingAutotaskChannelsValue: "KoliÄina svih odabranih kanala mora biti popunjena",
            missingAutotaskCleanTime: "Vreme ÄiÅ¡cÌenja mora biti popunjeno",
            missingAutotaskName: "Naziv autotaska mora biti popunjen",
            missingAutotaskRecirculation: "Vreme i brzina recirkulacije moraju biti popunjeni",
            missingAutotaskStirring: "Vreme i brzina meÅ¡anja moraju se popuniti",
            missingAutotaskVolume: "KoliÄina proÄiÅ¡cÌavanja mora biti popunjena",
            placeCanSensor:
                "PodeÅ¡avanje aktivira senzor za postavljanje kante - doziranje se nec?e pokrenuti ako kanta nije pravilno postavljena.",
            placeCanSensorDelay:
                "PreporuÄeno podeÅ¡avanje vezano za postavljanje senzora kante. Osigurava da doziranje poÄinje tek nakon definisanog vremenskog perioda tokom kojeg je kanta pravilno postavljena.",
            purgeVolume:
                "Zapremina ÄiÅ¡Äenja odreÄuje koliko koloranta je oÄiÅ¡Äeno prilikom obavljanja pametnog ÄiÅ¡Äenja.",
            rccUrl: "Redlike Control Center (RCC) is responsible for the communication with the dispenser.",
            refillThreshold:
                "If the amount of colorant in the canister with the given UFI or Batch number drops below this limit, such UFI or Batch number will be discarded.",
            refillThresholdBatch:
                "If the amount of colorant in the canister with the given Batch number drops below this limit, such Batch number will be discarded.",
            refillThresholdUfi:
                "If the amount of colorant in the canister with the given UFI drops below this limit, such UFI will be discarded.",
            removeCanSensor:
                "PodeÅ¡avanje aktivira senzor za uklanjanje kante - doziranje se ne smatra izvrÅ¡enim ukoliko kanta nije uklonjena.",
            removeCanSensorDelay:
                "PreporuÄeno podeÅ¡avanje vezano za uklanjanje senzora kante. Osigurava da je doziranje zavrÅ¡eno tek nakon odreÄenog vremenskog perioda tokom kojeg je kanta uklonjena.",
            skipPlaceCanDialog:
                "Kada je ovo podeÅ¡avanje ukljuÄeno, dispenzer nec?e Äekati kada se postavi kanta dok se ne pritisne taster OK, vec? c?e automatski pokrenuti postupak doziranja.",
            skipRemoveCanDialog:
                "Kada je ovo podeÅ¡avanje ukljuÄeno, dispenzer nec?e Äekati kada se ukloni kanta dok se ne pritisne taster OK, vec? c?e se smatrati da je proces doziranja automatski zavrÅ¡en.",
            smartPurgeType:
                "Tip ÄiÅ¡Äenja moÅ¾e uzeti u obzir samo doziranje ili doziranje plus druge dogaÄaje ÄiÅ¡c?enja prilikom provere ukoliko je potrebno pametno ÄiÅ¡c?enje.",
            splitFormula:
                "Ako potrebna koliÄina koloranta prelazi maksimalnu koliÄinu doziranja, podeÅ¡avanje omoguc?ava ispuÅ¡tanje dela koloranta, ponovo punjenje kanistra, a zatim nastavljanje s doziranjem ostatka.",
            tintometricSystem:
                "Tintometric system (set of available colorants) defines what colorants and formulas will be available in the application and application settings.",
            validateBarcodeBaseCan:
                "Baza kante se mora potvrditi putem barkoda pre nego Å¡to se dozvoli punjenje. PodeÅ¡avanje osigurava da je upotrebljena ispravna baza. ",
            validateColorantsDuringInit:
                "The machine configuration will be compared to the database each time when RCC is restarted. In case of mismatches, a notification occurs."
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Defines how many results should be offered after matching."
        },
        navigation: {
            barcodeScan: "Opens a window with the possibility to enter the barcode manually.",
            canisterBarcodes:
                "Otvara prozor za pregledanje barkoda kanistera i mogucÌnosti podeÅ¡avanja barkoda kanistera.",
            canisterLevel: "Otvara prozor za pregledanje nivoa kanistera i mogucÌnosti podeÅ¡avanja nivoa kanistera.",
            canisters: "Otvara panel za pregledanje nivoa kanistera i mogucÌnosti podeÅ¡avanja nivoa kanistera.",
            clean: "Open a window with the possibility to clean machine channels",
            colorPanel: "Otvara panel sa mogucÌnoÅ¡cÌu traÅ¾enja nove formule u elektronskoj kolor karti.",
            colorSearchTab: "Opens a panel with possibility to search all colors in all fandecks.",
            colorantRefillHistory: "Otvara prozor za pregledanje izvrÅ¡enih dopuna kanistera",
            customFormula: "Otvara panel sa mogucÌnoÅ¡cÌu kreiranja nove prilagoÄene formule.",
            customers: "Otvara panel za pregledanje kupaca i mogucÌnoÅ¡cÌu njihovog dodavanja / ureÄivanja / brisanja.",
            dispensingHistory: "Otvara panel za pregledanje izvrÅ¡enih doziranja.",
            favorites: "Otvara panel sa mogucÌnoÅ¡cÌu odabira omiljene formule.",
            help: "Otvara prozor sa podacima o korisniÄkoj usluzi u sluÄaju da ih dobavljaÄ dostavi.",
            hideItems: "Opens a window with the possibility to mark products and fandecks as hidden.",
            historyOfOrders: "Dostupno za %{name} iskljuÄivo, otvara panel za pregledanje izdatih naloga.",
            machineReset: "PoÄinje resetovanje dispenzera.",
            matching: "Opens a panel with the possibility to match new color with a spectro.",
            myOrders: "NarudÅ¾be koje su poslate sa ovog raÄunara",
            purge: "Otvara prozor sa mogucÌnoÅ¡cÌu podeÅ¡avanja proÄiÅ¡cÌavanja kanistera.",
            quickTint: "Otvara prozor sa mogucÌnoÅ¡cÌu ruÄnog doziranja.",
            searchFormula: "Otvara panel sa mogucÌnoÅ¡cÌu traÅ¾enja nove formule.",
            spectro: "Otvara panel sa mogucÌnoÅ¡cÌu merenja spektrometrom.",
            stir: "Otvara prozor sa mogucÌnoÅ¡cÌu podeÅ¡avanja meÅ¡anja kanista.",
            ticketing: "Opens a ticketing system panel.",
            toDispense: "NarudÅ¾be koje je primio ovaj raÄunar"
        },
        noHelpForLicense: "Ne postoji dostupna pomoc? za vaÅ¡u licencu, traÅ¾ite od svog dobavljaÄa da je doda",
        posInfo: {
            sync: "Sinhronizuje podatke sa sekcijom Registracija"
        },
        poweredByDeso: "Pokrenuto od %{name}",
        priceSettings: {
            VatPrice: "Vrednost PDV-a koloranta  u%.",
            VatPriceProduct: "The generic product VAT will be the same for every colorant. Set in %.",
            basePurchase: "Kupovna cena za bazu (uklj. bazu iskljuÄivo).",
            basePurchasePriceProduct: "Purchase price for the package of the given base. Set in selected currency.",
            baseSell: "Prodajna cena samo za bazu (uklj. bazu i marginu/marÅ¾u)",
            baseSellFull: "Sell full price for base.",
            cntName: "Defines which colorant the price is related to.",
            cntPurchase: "Nabavna cena za boje (ukljuÄujuc?i kolorante iskljuÄivo)",
            cntPurchaseByName:
                "Nabavna cena za kolorante, koja se izraÄunava pojedinaÄno za svaki (ukljuÄujuc?i iskljuÄivo kolorante)",
            cntPurchasePricePerLiter: "Cena koÅ¡tanja koloranta po litru (bez margine ili marÅ¾e).",
            cntSell: "Prodajna cena samo za kolorante (ukljuÄujuc?i kolorante i marginu/marÅ¾u)",
            cntSellByName:
                "Prodajna cena za sve kolorante koji se koriste u proizvodu izraÄunava se pojedinaÄno za svaki (ukljuÄujuc?i kolorante i marginu/marÅ¾u).",
            cntSellFull: "Sell full price for colorants.",
            cntSellFullByName: "Sell full price for colorants by name.",
            cntSellPricePerLiter:
                "The sell price of the colorant per liter (incl. colorant exclusively). Set in the selected currency.",
            cntVat: "Colorant VAT value set in %.",
            colorants:
                "Cene generiÄkih koloranata bic?e iste za svaki kolorant. Ova funkcija je korisna posebno za podeÅ¡avanje PDV-a.",
            colorantsPosCoeficient: "The generic colorant coeficient for POS.",
            colorantsSellPrice:
                "The generic colorant prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            currencyCodeNew: "Kod valute mora biti u zvaniÄnoj formi tree-letter, na primer EUR",
            currencyNameNew: "Naziv valute, na primer Evro.",
            currencyRateNew:
                "Kurs valute prema glavnoj valuti, na primer 25,855 CZK za 1 â¬. Kurs je potrebno kontinuirano ureÄivati da bi bio aÅ¾uran.",
            currencyRoundingNew:
                "ZaokruÅ¾ivanje postavlja najmanju moguc?u vrednost valute, na primer Evro ima zaokruÅ¾ivanje 0,01, jer je najmanja moguc?a vrednost 1 cent.",
            currencySymbolNew: "ZvaniÄni simbol valute, na primer, â¬ za evro.",
            defaultPrice: "Cena koloranta u izabranoj bazi podataka (bez PDV-a)",
            defaultPriceGroup: "Cena koloranta u cenovnoj grupi postavljena u odabranoj bazi podataka (bez PDV-a).",
            defaultVatPrice: "PDV koloranta postavljenog u izabranoj bazi podataka",
            discountHeader: "Discount substracts the the defined value from the purchase colorant price. Set in %.",
            discountHeaderProduct:
                "Discount substracts the the defined value from the product colorant price. Set in %.",
            export: "Export a file with the currently inserted prices. It can be imported again after having modified the prices.",
            import: "Import a correctly formated (exported) file to insert or modify the prices.",
            localPrices:
                "Local prices change suggested prices from the main database and are present solely locally on this particular computer.",
            margin: "Choose which price calculation should be used for the definition of the final available price. Margin and markup add up to whereas discount substracts from the given sell price.",
            marginAll: "Cena za marginu/marÅ¾u za viÅ¡e pakovanja (ukljuÄujuc?i marginu/marÅ¾u)",
            marginHeader: "Margin adds the defined value up to the purchase colorant price. Set in %.",
            marginHeaderProduct: "Margin adds the defined value up to the purchase product price. Set in %.",
            marginPerPkg: "Cena za marginu/marÅ¾u za jedan paket (ukljuÄujuÄi marginu/marÅ¾u)",
            markupHeader: "Markup adds the defined value up to the purchase colorant price. Set in %.",
            markupHeaderProduct: "Markup adds the defined value up to the purchase product price. Set in %.",
            packagePricing: "Dodatna doplata se postavlja pojedinaÄno za svaku veliÄinu pakovanja.",
            packageSurcharge: "Cene generiÄkih pakovanja bic?e iste za svaku doplatu pakovanja.",
            priceDefinition: "The setting defines which price types are used when calculating final prices.",
            priceGroupNumber:
                "The setting defines how many price groups will be used. The range for individual price groups can be set in Default Values.",
            priceGroupPricePerLiter: "Cena koloranta koja se koristi za izraÄunavanje cene cenovne grupe.",
            priceGroups:
                "Cenovne grupe prikazuju broj relevantne cenovne grupe (granice su postavljene u bazi podataka ili u generiÄkim cenama).",
            priceGroupsEnabled:
                "The setting allows you to work with price groups. Define the range in Default Values and individual prices in Colorant Pricing.",
            priceGroupsGeneric:
                "Cenovne grupe predstavljaju intervale cena zavrÅ¡ne boje na osnovu cene koloranta u recepturi.",
            productBasePackageSellPrice: "Sell price for the package of the given base. Set in selected currency.",
            productBaseSellPrice:
                "Sell price for base calculated per liter (incl. base exclusively). Set in the selected currency.",
            productBaseVat: "Product base VAT value for the given package set in %.",
            productName: "Defines which product base the price is related to.",
            productPosCoeficient: "The generic product coeficient for POS.",
            productPricing: "Nabavna cena za sve pakete se koristi prilikom doziranja prilagoÄenih pakovanja.",
            productSize: "Defines which package of the given product base the price is related to.",
            productVat: "Product base VAT value set in %.",
            products:
                "Cene generiÄkih proizvoda bic?e iste za svaki proizvod. Ova funkcija je korisna posebno za podeÅ¡avanje PDV-a.",
            productsSellPrice:
                "The generic product prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            sellPriceAll: "Prodajna cena viÅ¡e pakovanja (ukljuÄujuc?i bazu, kolorante, doplatu i marginu/marÅ¾u).",
            sellPricePerKg:
                "Prodajna cena proizvoda po kilogramu (ukljuÄujuc?i bazu, kolorante, doplatu i marginu/marÅ¾u).",
            sellPricePerL: "Prodajna cena proizvoda po litru (ukljuÄujuc?i bazu, kolorante, doplatu i marginu/marÅ¾u).",
            sellPricePerPkg: "Prodajna cena jednog pakovanja (ukljuÄujuc?i bazu, kolorante, doplatu i marginu/marÅ¾u).",
            setPriceTypesVisibilityAndOrder:
                "Na Receptura panelu, izabrane cene c?e biti vidljive u delu sa cenama. NajviÅ¡i poloÅ¾aj ovde definiÅ¡e krajnji levi poloÅ¾aj u sekciji.",
            surchargeAll: "Cena dodatne naknade za viÅ¡e pakovanja (ukljuÄujuÄi doplatu).",
            surchargePerPkg: "Cena dodatne naknade za jedno pakovanje (ukljuÄujuÄi doplatu).",
            tintPurchaseAll:
                "Nabavna cena za celokupan postupak nijansiranja viÅ¡e pakovanja (ukljuÄujuc?i kolorante i doplatu)",
            tintPurchasePerPkg:
                "Nabavna cena za celokupan postupak nijansiranja jednog pakovanja (ukljuÄujuc?i kolorante i doplatu)",
            tintSellFullAll: "Tint sell full price for all packages.",
            tintlSellFullAllPerPackage: "Tint sell full price per package.",
            totalPurchaseAll: "Ukupna nabavna cena proizvoda za viÅ¡e pakovanja (ukljuÄujuc?i bazu i kolorante).",
            totalPurchasePerKg: "Ukupna nabavna cena proizvoda po kilogramu (ukljuÄujuc?i bazu i kolorante).",
            totalPurchasePerL: "Ukupna nabavna cena proizvoda po litru (ukljuÄujuc?i bazu i kolorante).",
            totalPurchasePerPkg: "Ukupna nabavna cena proizvoda ze jedno pakovanje (ukljuÄujuc?i bazu i kolorante).",
            totalSellFullAll: "Total sell full price for all packages.",
            totalSellFullPerKg: "Total sell full price per kilogram.",
            totalSellFullPerLiter: "Total sell full price per liter.",
            totalSellFullPerPackage: "Total sell full price per package.",
            withAndWithoutVat: "Na panelu Formule cena cÌe biti vidljiva istovremeno u obe varijacije, sa i bez PDV-a.",
            withVat: "Na panelu Formule sve cene cÌe biti vidljive samo sa uraÄunatim PDV-om.",
            withoutVat: "Na panelu Formule sve cene cÌe biti vidljive samo bez PDV-a."
        },
        qualityControlSettings: {
            colorDifference: "Color difference model for quality control.",
            deltaA: "Defines tolerance limit for delta A in quality control.",
            deltaB: "Defines tolerance limit for delta B in quality control.",
            deltaE: "Defines tolerance limit for delta E in quality control.",
            deltaL: "Defines tolerance limit for delta L in quality control.",
            deltaMetamerism: "Defines tolerance limit for metamerism delta in quality control."
        },
        registration: {
            sync: "Sinhronizuje podatke sa sektorom POS informacija"
        },
        searchingPleaseWait: "Please wait, the best match is being searched for",
        setupSteps: {
            customData: "Custom Data",
            machineType: "Machine Type",
            userPreferences: "User Preferences"
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "When using profiled values, the measured results are recalculated to remove the filter effect. Allow this option for universal spectro measuring.",
            XRiteModelRM400: "No drivers required.",
            datacolorDiagnosticTile: "Datacolor use diagnostic tile",
            datacolorSilent: "Datacolor silent",
            measureModes: "Select supported gloss levels.",
            model: "Model",
            simulationPath: "Path to the simulation file. Default preset.",
            spectroType: "Official spectro driver has to be installed. Windows only.",
            spectroTypeCom:
                "Official spectro driver has to be installed. Beware of the used COM Port. Windows as well as Linux.",
            spectroTypeDataColorReader:
                "The computer has to have Bluetooth connection. The spectro has to be paired with the computer. Windows 10 with 2018 automn update required.",
            spectroTypeMinolta2XXXd:
                "Official spectro driver has to be installed. Beware of the used COM Port. Windows as well as Linux.",
            spectroTypeNotSelected: "Select your spectro model.",
            spectroTypeRM400: "No drivers required.",
            spectroTypeSimulation: "Lab values required to obtain simulation results. Windows as well as Linux.",
            spectroTypeXRite: "Windows only."
        },
        ufiCode: {
            baseUfiCodeValidation: "Base can UFI code has to be validated via barcode before dispensing is allowed.",
            enableUfiCodes:
                "UFI codes are used in EU and provide information about how hazardous a product is to environment.",
            invalidUfi: "Invalid UFI code",
            printUfiCode:
                "If a colorant in a formula exceeds the given limit, its UFI code will be printed on the print label.",
            printUfiCodePercentage:
                "If a colorant in a formula exceeds the given limit, its UFI code will be printed on the print label along with its percentage representation.",
            ufiCodesByPercentage:
                "The UFI code which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            ufiCodesFromDatabase:
                "The UFI code from the main database given by the database administrator is used for printing.",
            ufiCodesFromLastFilling:
                "The UFI code from the last refill given by the operator is used for printing regardless the refilled amount."
        },
        userManagement: {
            add: "The setting adds a new user who can log in into the software. The user can have a barcode assigned and can be set to log in automatically after the software is started.",
            assignedGroups:
                "This defines what user groups the user belongs to. Various user groups distribute various privileges.",
            availableGroups:
                "This defines what user groups there are available for the user. Various user groups distribute various privileges.",
            loggedUserDelete: "Currently logged in user cannot be deleted."
        },
        visit: "Ili posetite",
        visitNoLicense: "Za viÅ¡e informacija, molimo posetite"
    },
    helpSettings: {
        customHelpLink: "PrilagoÄen Centar PomoÄi link",
        helpSettings: "PodeÅ¡avanje pomoÄi",
        message: "Poruka"
    },
    helper: {
        automaticallyCheckForUpdates: "Automatski proverite aÅ¾uriranje",
        automaticallyDownloadUpdates: "Preuzimanje aÅ¾uriranja automatski",
        automaticallyInstallNewDatabases: "Automatski instalirajte nove baze podataka",
        automaticallyInstallUpdates: "Automatski instalirajte aÅ¾uriranja",
        bugReport: "IzveÅ¡taj o greÅ¡ci",
        canBrowseChangeLog: "Show online %{name} changelog.",
        collect: "Sakupi",
        collectLogFiles: "Sakupite datoteke prijave",
        component: "Komponenta",
        content: "SadrÅ¾aj",
        contentSize: "VeliÄina sadrÅ¾aja",
        download: "Preuzimanje",
        downloadLogFiles: "Preuzmite datoteke prijave",
        downloadingData: "Preuzimanje podataka",
        everyHours: "Svaki %{interval} sati",
        forceInstall: "Force to update",
        installDuringNight: "During night (%{start} - %{end}) every %{interval} hour",
        newVersion: "Nova verzija",
        notConnected: "Pomoc?nik nije povezan",
        openBugReport: "Otvori izveÅ¡taj o greÅ¡ci",
        packageSize: "VeliÄina pakovanja",
        pleaseWait: "Molimo saÄekajte, ovo moÅ¾e potrajati",
        send: "PoÅ¡aljite",
        sendBugReportToCustomerService: "PoÅ¡aljite izveÅ¡taj o greÅ¡ci sluÅ¾bi za korisnike",
        sendingReport: "Slanje",
        subject: "Predmet"
    },
    helperDialog: {
        1: "MoÅ¾ete proveriti aÅ¾uriranje softvera ili baze podataka.",
        2: "Å½elite li nastaviti sa preuzimanjem paketa za aÅ¾uriranje?",
        3: "Nastaviti sa instalacijom preuzetih paketa za aÅ¾uriranje?",
        10: "Provera aÅ¾uriranja softvera i baze podataka, molimo saÄekajte...",
        11: "Dostupno je aÅ¾uriranje za vaÅ¡ raÄunar. Da li Å¾elite da ga preuzmete?",
        12: "Nisu dostupna aÅ¾uriranja za vaÅ¡ raÄunar.",
        14: "DoÅ¡lo je do greÅ¡ke tokom provere aÅ¾uriranja. %{0}",
        15: "Sinhronizovanje zone baza podataka, molimo saÄekajte...",
        20: "Preuzimanje paketa aÅ¾uriranja, molimo saÄekajte...",
        21: "Paket aÅ¾uriranja koji je preuzet sada se verifikuje, molimo saÄekajte...",
        22: "Preuzimanje paketa aÅ¾uriranja nije uspelo, da li Å¾elite da pokuÅ¡ate ponovo?",
        23: "Preuzimanje paketa aÅ¾uriranja nije uspelo (datoteka je nepravilno oblikovana), da li Å¾elite da pokuÅ¡ate ponovo?",
        24: "Nastavite sa instalacijom aÅ¾uriranja?",
        25: "Instalacija automatskog aÅ¾uriranja poÄec?e u %{0}",
        26: "Dostupno je aÅ¾uriranje za vaÅ¡ raÄunar. Da li Å¾elite da ga preuzmete?",
        27: "Nastavite sa instalacijom aÅ¾uriranja?",
        40: "Zaustavljanje aplikacija i usluga, molimo saÄekajte...",
        41: "Kopiranje novih datoteka, molimo saÄekajte...",
        42: "Pokretanje aplikacija i usluga, molimo saÄekajte...",
        43: "ZavrÅ¡avanje aÅ¾uriranja softvera, molimo saÄekajte...",
        44: "Softver je uspeÅ¡no aÅ¾uriran.",
        45: "Å½elite li da ponovo pokuÅ¡ate instaliranje? Ako odluÄite da pokuÅ¡ate ponovo, uverite se da se softverske komponente trenutno ne koriste.",
        46: "Restartovanje raÄunara je neophodno za prihvatanje promena, ponovno pokretanje c?e biti izvrÅ¡eno u %{0}",
        999: "DoÅ¡lo je do interne greÅ¡ke: %{0}",
        automaticInstallation: "Instalacija automatske aÅ¾uriranje",
        btnAbort: "Prekid  ",
        btnCancel: "Otkazati",
        btnCheckUpdate: "Proveriti za aÅ¾uriranja",
        btnContinue: "Nastaviti",
        btnDownloadUpdate: "Preuzimanje aÅ¾uriranja",
        btnInstallUpdate: "Instalirajte aÅ¾uriranje",
        btnOk: "U redu",
        btnRetry: "Ponoviti",
        btnSkip: "PreskoÄiti",
        checkingForUpdates: "Provera aÅ¾uriranja",
        downloadingFailed: "Preuzimanje nije uspelo",
        downloadingPackage: "Preuzimanje paket aÅ¾uriranja, molimo saÄekajte",
        finishingUpdate: "DovrÅ¡avanje aÅ¾uriranje",
        installingUpdate: "Instaliranje aÅ¾uriranja",
        internalError: "Interna pogreÅ¡ka",
        rebootRequired: "Potreban restart raÄunara",
        startingComponents: "Pokretanje softverskih komponenata",
        stoppingComponents: "Zaustavljanje softverskih komponenata",
        synchronizingDatabases: "Sinhronizovanje zonu baza podataka",
        updateAvailable: "AÅ¾uriranje je dostupno, odaberite komponente koje treba aÅ¾urirati",
        updateDownloaded: "Update je preuzeto",
        updateFailed: "Proces aÅ¾uriranja nije uspeo",
        updateInstalled: "AÅ¾uriranje je instalirano",
        verificationFailed: "Provera aÅ¾uriranja paketa nije uspela",
        verifyingPackage: "Provera preuzetog paketa",
        yourSoftwareIsUpToDate: "VaÅ¡ softver aÅ¾uran",
        yourSoftwareVersion: "Verzija vaÅ¡eg softvera: %{0}"
    },
    importData: {
        abortImportingData: "Prekini uvoÄenje",
        aborted: "Unos je prekinut.",
        backupLocalDB: "Backup local database",
        confirmRestore: "Do you really want to restore all local settings?",
        dataMissing: "Unos nije uspeo jer izvorna datoteka nije sadrÅ¾ala nikakve podatke.",
        deleteImportedData: "IzbriÅ¡ite unete podatke",
        encodingFile: "Kodiranje datoteka",
        exportLocalSettings: "Export Local Settings",
        exportStaticSql: "Export Static SQL",
        fileDamaged: "Unos nije uspeo jer se Äini da je izvorna datoteka oÅ¡tecÌena.",
        fileMissing: "Unos nije uspeo jer izvorna datoteka ne postoji.",
        format: "Format",
        formatPath: "Staza formatiranja",
        headerMissing: "Unos nije uspeo jer nedostaje zaglavlje datoteka.",
        import: "Uneti",
        importAborted: "UvoÄenje je prekinuto",
        importAborting: "Prekid uvoÄenje  ",
        importFailed: "Unos nije uspeo zbog neoÄekivane greÅ¡ke.",
        importLocalSettings: "Import Local Settings",
        importPrices: "UvoÄenje cena",
        imported: "UspeÅ¡no je uvoÄeno",
        importedWithErrors: "Importing has finished with errors. Error lines have been skipped.",
        importing: "UvoÄenje",
        noFormatAvailable: "Nema dostupnog formata",
        processing: "Obrada",
        processingCustomFormulas: "Obrada prilagoÄenih receptura",
        processingCustomers: "Obrada kupaca",
        productsFile: "Datoteka sa proizvodima",
        restoreLocalSettings: "Restore Local Settings",
        underProgress: "Unos je u toku",
        unknownFormat: "Unos nije uspeo jer je izvorna datoteka nepoznatog formata.",
        userFormulasFile: "Datoteka korisniÄkih receptura"
    },
    infoType: {
        baseDensity: "Gustina baze",
        baseMass: "Masa baze",
        baseUfiCode: "Base UFI code",
        baseVolume: "Zapremina baze",
        batchNumbersTable: "Batch numbers table",
        bfsGrade: "Stepen BFS",
        colorLab: "Color Lab",
        colorRgb: "Color RGB",
        colorRgbHex: "Color RGB Hex",
        colorXyz: "Color xyz",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantMass: "Masa koloranta",
        colorantUfiCodes: "Colorant UFI codes",
        colorantVolume: "Zapremina koloranta",
        formulaDate: "Formula date",
        formulaDatetime: "Formula datetime",
        formulaMoreInfo: "Formula more info",
        formulaMoreInfoInternal: "Formula more info internal",
        formulaMoreInfoPrint: "Formula more info print",
        hbw: "HBW",
        isPackageGravimetric: "Pakovanje je gravimetriÄno",
        maxColorantMass: "Maksimalna dozvoljena masa koloranata",
        maxColorantVolume: "Maksimalna dozvoljena zapremina koloranata",
        nominalMass: "Nominalna masa pakovanja",
        nominalVolume: "Nominalna zapremina pakovanja",
        overfillDetected: "ObeleÅ¾eno prelivanje",
        totalPaintDensity: "Total paint density",
        totalPaintMass: "Ukupna masa boje",
        totalPaintVolume: "Ukupna zapremina boje",
        ufiCodesTable: "UFI codes table",
        verifiedFormula: "Verified formula",
        yValue: "? vrednost"
    },
    initialTab: {
        favoriteFormulas: "Omiljene recepture",
        lastDispensedFormulas: "Poslednja dozirana receptura",
        searchNewFormula: "PotraÅ¾ite novu recepturu"
    },
    invalidBatchNumbersModal: {
        header: "Check colorants Batch number",
        info: "At least one canister is filled with (possibly) defective batch of colorant. Please do not use this batch. Empty the canister using Quick tint.",
        unknownStatus: "Unknown Batch status"
    },
    keyWords: {
        action: "action",
        add: "add",
        addition: "addition",
        additional: "additional",
        address: "address",
        admin: "admin",
        advanced: "Advanced",
        after: "after",
        afterDispensing: "after dispensing",
        alfa: "Alfa",
        all: "all",
        allow: "allow",
        alphabetically: "alphabetically",
        amount: "amount",
        api: "api",
        ask: "ask",
        autocap: "autocap",
        autotask: "autotask",
        availablePrice: "available price",
        backup: "backup",
        banner: "banner",
        barcode: "barcode",
        barcodes: "barcodes",
        base: "base",
        before: "before",
        begin: "begin",
        bfs: "bfs",
        bottom: "bottom",
        brand: "brand",
        brush: "brush",
        bug: "bug",
        button: "button",
        buy: "buy",
        cC3: "CC3",
        cM: "CM",
        calibration: "calibration",
        can: "can",
        canHandling: "can handling",
        canister: "canister",
        canisterFilling: "canister filling",
        canisterLevels: "canister levels",
        canisters: "canisters",
        cap: "cap",
        center: "Center",
        centre: "Centre",
        change: "change",
        changelog: "changelog",
        channels: "channels",
        check: "check",
        chunk: "chunk",
        chunks: "chunks",
        city: "city",
        clean: "clean",
        cleaning: "cleaning",
        clientIdentifier: "client identifier",
        close: "close",
        closest: "closest",
        code: "code",
        collect: "collect",
        color: "color",
        colorLink3: "ColorLink3",
        colorPanel: "color palette",
        colorReader: "ColorReader",
        colorant: "colorant",
        colorantConsumption: "colorant consumption",
        colorantPrice: "colorant price",
        colorants: "colorants",
        colorix: "Colorix",
        colour: "colour",
        communication: "communication",
        compare: "compare",
        competitive: "competitive",
        computer: "computer",
        config: "config",
        configuration: "configuration",
        confirm: "confirm",
        confirmation: "confirmation",
        connection: "connection",
        contactPerson: "contact person",
        control: "Control",
        copies: "copies",
        corob: "Corob",
        cost: "cost",
        country: "country",
        create: "create",
        currency: "currency",
        current: "current",
        custom: "custom",
        customers: "customers",
        daily: "daily",
        dark: "Dark",
        data: "data",
        database: "database",
        datacolor: "Datacolor",
        date: "date",
        decimals: "decimals",
        default: "default",
        delay: "delay",
        delete: "delete",
        deletion: "deletion",
        deltaE: "delta e",
        device: "device",
        devices: "devices",
        diagnosticTile: "diagnostic tile",
        dialog: "dialog",
        direct: "direct",
        disconnect: "disconnect",
        discount: "discount",
        dispense: "dispense",
        dispenser: "dispenser",
        dispensing: "dispensing",
        down: "down",
        download: "download",
        driver: "driver",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "edit",
        editor: "editor",
        email: "email",
        error: "error",
        evoDriver: "EvoDriver",
        evoService: "EvoService",
        excel: "excel",
        expiration: "expiration",
        export: "export",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "fandeck",
        fastFluid: "Fast & Fluid",
        file: "file",
        fill: "fill",
        fillToMax: "fill to max",
        find: "find",
        first: "first",
        flex: "Flex",
        folder: "folder",
        formula: "formula",
        formulas: "formulas",
        from: "from",
        fts5: "fts5",
        fullScreen: "full screen",
        fullText: "full-text",
        fulltext: "fulltext",
        g: "g",
        genericPricing: "generic pricing",
        hLD: "HLD",
        hard: "hard",
        hbw: "hbw",
        help: "help",
        helpCenter: "help center",
        hero: "Hero",
        history: "history",
        home: "home",
        host: "host",
        humidifier: "humidifier",
        iDD: "IDD",
        identification: "identification",
        image: "image",
        impGallon: "imp. gallon",
        impQuart: "imp. quart",
        import: "import",
        individually: "individually",
        info: "info",
        information: "information",
        initial: "initial",
        initialization: "initialization",
        initialize: "initialize",
        insert: "insert",
        install: "install",
        intellyPurge: "intelly purge",
        invalid: "invalid",
        ipAddress: "ip address",
        italtinto: "Italtinto",
        items: "items",
        keyboard: "keyboard",
        kg: "kg",
        kiosk: "kiosk",
        kioskMode: "kiosk mode",
        l: "l",
        lLD: "LLD",
        lab: "lab",
        label: "label",
        labels: "labels",
        language: "language",
        largo: "largo",
        last: "last",
        lenteq: "Lenteq",
        levels: "levels",
        license: "license",
        light: "Light",
        limit: "limit",
        link: "link",
        linux: "Linux",
        load: "load",
        lock: "lock",
        logFiles: "log files",
        logic: "logic",
        logo: "logo",
        lower: "lower",
        machine: "machine",
        machineConfiguration: "machine configuration",
        machineManagement: "machine management",
        machineName: "machine name",
        main: "main",
        maintenance: "maintenance",
        manual: "manual",
        manualAddition: "manual addition",
        manualDispensing: "manual dispensing",
        manualScan: "manual scan",
        margins: "margins",
        markups: "markups",
        mass: "mass",
        match: "match",
        measure: "measure",
        measurement: "measurement",
        measurementUnits: "measurement units",
        melody: "melody",
        message: "message",
        minimal: "minimal",
        minolta: "Minolta",
        minus: "minus",
        minutes: "minutes",
        misura: "Misura",
        ml: "ml",
        mode: "mode",
        model: "model",
        modification: "modification",
        modify: "modify",
        monthly: "monthly",
        moreInfo: "more info",
        movableTable: "movable table",
        move: "move",
        music: "music",
        myOrders: "my orders",
        name: "name",
        naming: "naming",
        nano: "Nano",
        navigation: "navigation",
        new: "new",
        nextDriver: "NextDriver",
        night: "night",
        nixPro: "Nix Pro",
        notes: "notes",
        notification: "notification",
        number: "number",
        off: "off",
        open: "open",
        order: "order",
        ordering: "ordering",
        overfill: "overfill",
        overview: "overview",
        overwrite: "overwrite",
        own: "own",
        pCPDriver: "PCPDriver",
        package: "package",
        packagePrice: "package price",
        packages: "packages",
        panels: "panels",
        parameter: "parameter",
        path: "path",
        pc: "pc",
        phone: "phone",
        phoneNumber: "phone number",
        picture: "picture",
        place: "place",
        placement: "placement",
        plug: "plug",
        plugger: "plugger",
        plugging: "plugging",
        plugin: "plugin",
        plus: "plus",
        pointOfSale: "point of sale",
        popUp: "pop-up",
        pos: "pos",
        present: "present",
        preview: "preview",
        price: "price",
        priceExport: "price export",
        priceGroup: "price group",
        priceImport: "price import",
        prices: "prices",
        pricing: "pricing",
        primaryCurrency: "primary currency",
        print: "print",
        printer: "printer",
        printing: "printing",
        problem: "problem",
        product: "product",
        productPrice: "product price",
        profiledValues: "profiled values",
        punch: "punch",
        puncher: "puncher",
        punching: "punching",
        purge: "purge",
        purgeType: "purge type",
        purgeVolume: "purge volume",
        quality: "quality",
        quick: "quick",
        quickTint: "quick tint",
        rM: "RM",
        raise: "raise",
        rcc: "rcc",
        reader: "reader",
        reboot: "reboot",
        receive: "receive",
        recirculate: "recirculate",
        recirculation: "recirculation",
        redlike: "Redlike",
        refill: "refill",
        registration: "registration",
        regular: "regular",
        removal: "removal",
        remove: "remove",
        report: "report",
        reset: "reset",
        resolution: "resolution",
        restart: "restart",
        rgb: "rgb",
        rights: "rights",
        rounding: "rounding",
        rules: "rules",
        sanTint: "SanTint",
        save: "save",
        scale: "scale",
        scan: "scan",
        scope: "scope",
        screen: "screen",
        screensaver: "screensaver",
        search: "search",
        secondaryCurrency: "secondary currency",
        select: "select",
        selectedFormula: "Selected formula",
        sell: "sell",
        sensor: "sensor",
        serialNumber: "serial number",
        server: "server",
        servers: "servers",
        service: "service",
        serviceAction: "service action",
        serviceActions: "service actions",
        serviceSoftware: "service software",
        serviceWindow: "service window",
        settings: "settings",
        shelf: "shelf",
        shortcuts: "shortcuts",
        shot: "shot",
        show: "show",
        shutDown: "shut down",
        shutdown: "shutdown",
        silent: "Silent",
        simple: "simple",
        simulation: "simulation",
        size: "size",
        skip: "skip",
        smartPurge: "smart purge",
        software: "software",
        softwareSupplier: "software supplier",
        sort: "sort",
        sound: "sound",
        spectro: "spectro",
        spectrophotometer: "spectrophotometer",
        speed: "speed",
        split: "split",
        start: "start",
        startup: "startup",
        statistics: "statistics",
        status: "status",
        stir: "stir",
        stirring: "stirring",
        street: "street",
        support: "support",
        surcharge: "surcharge",
        tab: "tab",
        tabs: "tabs",
        task: "task",
        template: "template",
        testing: "testing",
        time: "time",
        tintingManagementCenter: "tinting management center",
        to: "to",
        toDispense: "to dispense",
        tolerance: "tolerance",
        top: "top",
        total: "total",
        translation: "translation",
        turnOff: "turn off",
        turntable: "turntable",
        type: "type",
        uIDD: "UIDD",
        uSGallon: "U.S gallon",
        uSQuart: "U.S quart",
        unit: "unit",
        up: "up",
        update: "update",
        url: "url",
        user: "user",
        userGroups: "user groups",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "VAT",
        validate: "validate",
        validation: "validation",
        version: "version",
        virtual: "virtual",
        volume: "volume",
        weekly: "weekly",
        window: "window",
        windows: "Windows",
        with: "with",
        without: "without",
        xRite: "X-Rite",
        xrite: "Xrite",
        yValue: "y value",
        zipCode: "zip code",
        zoom: "zoom"
    },
    languages: {
        bg: "Ð±ÑÌÐ»Ð³Ð°ÑÑÐºÐ¸",
        cs: "ÄeÅ¡tina",
        da: "Danish",
        de: "Deutsch",
        el: "ÎÎ»Î»Î·Î½Î¹ÎºÎ¬",
        en: "English",
        es: "Espa?ol",
        fr: "FranÃ§ais",
        hr: "Hrvatski",
        hu: "Magyar",
        id: "Bahasa Indonesia",
        is: "Ãsland",
        it: "Italiano",
        lt: "Lithuanian",
        lv: "Latvian",
        ms: "Melayu",
        nl: "Nederland",
        no: "Norway",
        pl: "Polski",
        pt: "Portugu?s",
        ro: "Romana",
        ru: "Ð ÑÑÑÐºÐ¸Ð¹",
        sk: "SlovenÄina",
        sr: "Srpski",
        sv: "Sverige",
        zh: "Chinese"
    },
    license: {
        activateLicense: "Aktivirajte licencu",
        activateNewLicense: "Aktivirajte novu licencu",
        checkLicenseKey: "Proverite licenÄni kljuÄ",
        companyId: "ID kompanije",
        contactPerson: "Kontakt osoba",
        copy: "Kopirajte",
        country: "Zemlja",
        emptyCity: "Grad je obavezna informacija",
        emptyCountry: "DrÅ¾ava je obavezna informacija",
        emptyName: "Name is a required information",
        enterIdentificationKeys: "Unesite svoje identifikacione kljuÄeve",
        expirationDate: "Datum isteka %{dateTime}",
        fillRegistration: "Popunite podatke o registraciji (pomerite se na dole da biste videli viÅ¡e)",
        insertLicense: "Umetnite generisani kljuÄ za aktivaciju van mreÅ¾e",
        invalidEmail: "Unet email je neispravan",
        invalidPhone: "Unet telefon je neispravan",
        itemsMarkedasterisk: "(stavke oznaÄene zvezdicom moraju biti popunjene)",
        lastUpdate: "Last change %{dateTime}",
        leasedLicense: "Zakupljena licenca",
        licenseActivated: "License already activated",
        licenseStatus: "Status licence",
        licenseWillExpire: "Your license expires in %{dayCount} days",
        licenseWillExpireOneDay: "Your license expires in %{dayCount} day",
        machineInformation: "Informacije o maÅ¡ini",
        noLicenseAvailable: "nije dostupna licenca",
        noProductsForKey: "Ne postoje dostupni proizvodi za navedene identifikacijske kljuÄeve.",
        pointOfSale: "POS - Mesto prodaje",
        producer: "ProizvoÄaÄ",
        reactivate: "Reactivate",
        reactivateLicense: "Reactivate license",
        region: "Region",
        registerLicense: "Molimo uzmite kopiju zahteva za aktivaciju i idite na:",
        registrationForm: "Registracija",
        selectProduct: "Izaberite proizvod",
        serialNumber: "Serijski broj",
        skipNewLicense: "If you want to activate new license later you can click on Skip",
        unlimitedLicense: "NeograniÄena licenca",
        userId: "ID korisnika",
        uuid: "Licenca UUID",
        versionDetails: "Detalji verzije",
        versionScope: "Poljeverzije",
        versionType: "Tip verzije",
        zip: "PoÅ¡tanski broj"
    },
    login: {
        authenticate: "Authenticate",
        logIn: "Prijavite se",
        loginAs: "Prijavite se kao drugi korisnik",
        messages: {
            incorrectUsername: "KorisniÄko ime ili lozinka su netaÄni"
        },
        password: "Lozinka",
        username: "KorisniÄko ime"
    },
    machineActionHistory: {
        actionHistory: "Istorijat akcija"
    },
    machineErrors: {
        channel: "Kanal  ",
        code: "Å ifra",
        machineErrors: "GreÅ¡ke maÅ¡ine",
        noMachineErrors: "There are currently no machine errors",
        resetErrors: "Resetujte greÅ¡ke"
    },
    machineSettings: {
        action: "Akcija",
        addAutotask: "Dodajte automatizaciju",
        autoCanisterIn: "Automatski kanister unutra",
        autoCanisterOut: "Automatski kanister van",
        automaticRefill: "Automatsko dopunjavanje",
        autotaskSettings: "PodeÅ¡avanja automatizacije",
        backupConfiguration: "Konfiguracija rezervnog dispenzera",
        brushMaintenance: "OdrÅ¾avanje Äetkica",
        capMaintenance: "OdrÅ¾avanje poklopca",
        checkCanisterBeforeDispense: "Proverite kanister pre nego Å¡to ga pustite",
        checkColorantBaseRules: "Check colorant base rules",
        checkMinDosableAmount: "Check the minimal tintable amount of colorants",
        checkOverfill: "Check can overfill",
        checkTotalCntAmounts: "Check total colorants amount for base paint",
        cleanAll: "OÄistite sve",
        computerReboot: "Restartovanje kompjutera",
        computerShutdown: "GaÅ¡enje kompjutera",
        connectMachine: "Povezivanje maÅ¡ine",
        days: "Dani",
        daysOfMonth: "Dani u mesecu",
        devices: "UreÄaji",
        disabled: "OnemoguÄeno",
        dispenseAndPurge: "Dozirajte i proÄistite",
        dispenseOnly: "Samo dozirajte",
        dispenserCleaning: "ÄiÅ¡Äenje dispenzera",
        dispensingWithErrorsEnabled: "Allow dispensing despite the validation errors",
        editAutotask: "Uredite automatizacije",
        firstRun: "First run",
        hours: "Sati",
        humidifier: "OvlaÅ¾ivaÄ",
        humidifierWaterLevelMaintenance: "OdrÅ¾avanje nivoa vode ovlaÅ¾ivaÄa",
        machineConfigurationNoCanisters: "The machine configuration contains no canisters.",
        machineName: "Naziv maÅ¡ine",
        machineSettings: "PodeÅ¡avanja maÅ¡ine",
        manualPuncher: "RuÄni buÅ¡aÄ",
        minDispensedAmount: "Minimalna koliÄina doziranja",
        minutes: "Minuti",
        nextRun: "SledeÄi niz",
        noAutotasksSet: "No autotasks set",
        noDataAvailable: "No data available",
        noMachine: "Nijedna maÅ¡ina nije spojena",
        onStart: "Na poÄetku",
        plugger: "PrikljuÄak",
        postpone: "MoÅ¾e se odloÅ¾iti",
        puncher: "BuÅ¡aÄ",
        purgeAll: "ProÄistite sve",
        purgeOnly: "Purge only",
        recirculateAll: "RecirkuliÅ¡ite sve",
        recirculateChannels: "RecirkuliÅ¡ite kanale",
        recirculationSpeed: "Brzina recirkulacije",
        recirculationTime: "Vreme recirkulacije",
        refillAll: "Napunite sve",
        refillCanisters: "Napunite kanistre",
        runAt: "Dnevno u",
        runDefinedDaysAt: "OdreÄenim danima u",
        runEvery: "Pokrenite svaki",
        runInDays: "Pokrenite u danima",
        serialNum: "Serijski broj",
        settingsMachine: "PodeÅ¡avanja maÅ¡ine",
        smartPurgeAll: "Pametno ÄiÅ¡Äenje svega",
        smartPurgeChannels: "Kanali pametnog ÄiÅ¡Äenja",
        smartPurgeRules: "Pravila pametnog ÄiÅ¡Äenja",
        startType: "PoÄetni tip",
        stirAll: "MeÅ¡ajte sve",
        stirCanisters: "MeÅ¡ajte kanistre",
        stirringSpeed: "Brzina meÅ¡anja",
        stirringTime: "Vreme meÅ¡anja",
        switchPlateMaintenance: "OdrÅ¾avanje prekidaÄke ploÄe",
        theCurrentlySelectedMachine: "Trenutno odabrana maÅ¡ina",
        threshold: "Prag",
        turntable: "Pokretni sto",
        unifyColorantBatchForMultipleCans: "Unify colorant batch for multiple cans dispensings",
        volume: "Zapremina",
        weekdays: "Radni dani"
    },
    mainTab: {
        acceptedFormula: "Accepted formula",
        addBuildingSite: "Add building site",
        addToFavorites: "Dodajte u omiljene",
        alternativeFormulas: "Alternative formulas",
        alternativeValidFormulas: "Alternative valid formulas",
        buildingSiteSpecification: "Building site specification",
        colorantsAreInvalid: "Jedan ili viÅ¡e koloranata su neispravni",
        dispensedPackages: "Dozirana pakovanja",
        dispensingInProgress: "Doziranje u toku",
        dispensingIsAborted: "Doziranje je prekinuto",
        dispensingIsNotAvailable: "Doziranje nije dostupno",
        dispensingProgress: "%{done} od %{all}",
        editColorant: "Uredite kolorant",
        editNote: "Uredite beleÅ¡ku",
        findCompetitiveColor: "Try to find the competitive color",
        forceDispensing: "Prisiljeno doziranje",
        formulaInvalidColorants: "Receptura sadrÅ¾i nevalidne kolorante: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "Formula properties",
        hiddenFandecks: "Hidden fandecks",
        hiddenProducts: "Hidden products",
        historicalFormulas: "Istorijat receptura",
        lowerDeltaNumber: "Lower delta number more accurate match",
        machineError: "GreÅ¡ka maÅ¡ine",
        machineIsBusy: "MaÅ¡ina je zauzeta",
        machineNotConnected: "MaÅ¡ina nije povezana",
        manualColorantAddition: "RuÄno dodavanje boja",
        modifiedFormula: "Formula je modifikovana",
        modifiedFormulaInLab: "Formula modified in laboratory",
        newColorAfterScaling: "New color after scaling",
        newRgbNotAccuratelyMeasured: "New RGB is not accurately measured, it is only indicative",
        noBaseAvailable: "Nije dostupna nijedna baza",
        noBuildingSiteAvailable: "No building site info is available",
        noColorantForCorrection: "No additional colorants for correction selected",
        noColorants: "Nema boja",
        noCustomer: "Nema kupaca",
        noCustomers: "Nema dostupnih kupaca",
        noDispenseNotesAvailable: "Nisu dostupne beleÅ¡ke za doziranje",
        noFormulaAvailable: "You have selected a combination with no formula!",
        noFormulaSelected: "Nije odabrana nijedna formula",
        noInternalNotesAvailable: "No internal notes are available",
        noNotesAvailable: "Nisu dostupne beleÅ¡ke",
        noPackageAvailable: "No package is available",
        noPackageSelected: "Nije izabrano nijedno pakovanje",
        noProductAvailable: "No product is available",
        noResultsFound: "No results found",
        openLocalFile: "Open from local database",
        openOnlineFile: "Open from the Internet",
        order: "NarudÅ¾ba",
        orderingIsNotAvailable: "NaruÄivanje nije dostupno",
        originalColor: "Original color",
        overAvailableLevel: "Preko dostupnog nivoa",
        package: "Pakovanje",
        packageIsRequired: "Package is required",
        packaging: "Packaging",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "Å tampanje nije dostupno",
        productFiles: "Datoteke proizvoda",
        productFilesViewer: "Product files viewer",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Properties",
        regularPrice: "Standardna cena",
        resetFormulaData: "Nova receptura",
        rgbOnlyIndicative: "RGB only indicative!",
        saveAsCustom: "SaÄuvajte kao",
        saveToStatsIsNotAvailable: "Äuvanje u istorijatu nije dostupno",
        searchForCheaper: "Search for cheaper",
        selectFromCompetitive: "You can select color from the competitive colors.",
        specialPrice: "Specijalna cena",
        specialPriceVip: "Specijalna cena VIP",
        splitFormula: "Podelite recepturu",
        withVAT: "sa PDV-om",
        withoutVAT: "bez PDV-a"
    },
    marginSettings: {
        allBases: "Sve baze",
        allProducts: "Svi proizvodi",
        editMargin: "Uredite margine",
        marginAndDiscountWarning: "You have to set price calculation option for using margins and discounts.",
        marginSettings: "PodeÅ¡avanja margine",
        marginsFor: "Margina za",
        markupColorants: "Oznaka boje",
        sizeOfPackage: "VeliÄina paketa ",
        valueBase: "Value base",
        valueColorant: "Value colorant"
    },
    matching: {
        actualColor: "Actual color",
        allCorrections: "All corrections",
        allTillItems: "All till the items",
        auto: "Auto",
        autoSelectAll: "Auto all",
        canStartCorrection: "Then you can start correction.",
        canStartMatching: "Then you can start matching.",
        cannotBeUsed: "Matching cannot be used.",
        changeProductAndColorants: "Try change product or colorants",
        checkConfig: "Please check the matching configuration.",
        colorCorrection: "Color correction",
        colorIsIndicative: "Color preview is only indicative.",
        colorNotAccurate: "Color may not be accurately displayed, it always depends on your monitor settings.",
        colorantInDispensedFormula: "Colorants in dispensed formula",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "Connection problem",
        correctionHistory: "Correction history",
        correctionRunning: "Correction is running",
        draftFormula: "Draft formula",
        exclude: "Exclude",
        excludeAll: "Exclude all",
        include: "Include",
        includeAll: "Include all",
        invalidProduct: "It is not possible to do the matching for product %{productName}",
        itemOnly: "Item only",
        manualColorCorrection: "Manual color correction",
        matchFormula: "Match formula",
        matchingInformation: "Matching information",
        matchingResult: "Matching result",
        matchingRunning: "Matching is running",
        matchingSearchOptions: "Matching search options",
        measurement: "Measurement",
        noCorrection: "No correction found",
        noSpectralCurveProvided:
            "The connected device cannot be used for matching because it doesn't provide spectral curve",
        notAvailableForMatching: "Not available for matching",
        originalFormula: "Original formula",
        reformulate: "Reformulate",
        reformulationRunning: "Reformulation is running",
        resultColor: "Result color",
        saveAsCustomFormula: "Save as custom formula",
        searchInProgress: "Search in progress, please wait",
        selectColorfile: "Please select colorfile.",
        selectRequiredItems: "Please select product, base, colorants and package.",
        selectedResult: "Selected result",
        spectralDataNotAvailable: "Spectral data is not available",
        startCorrection: "Start correction",
        startMatching: "Start matching",
        targetColor: "Target color",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "Used for matching"
    },
    modal: {
        changeColorantUnit: "Promenite jedinicu boje",
        payAttention: "Obratite paÅ¾nju!"
    },
    module: {
        productGroups: "Product groups"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "Filter kolor karte",
            formulasOverLimit: "O %{count} rezultata. Molimo pokuÅ¡ajte da unesete viÅ¡e karaktera.",
            foundFormulas: "%{count} receptura pronaÄeno",
            help: "PomoÄ:",
            helpText:
                "Tip npr. '%{filter}' za pretraÅ¾ivanje recepture koje poÄinju sa '%{formula}', proizvod poÄinja sa '%{product}' i kolor karta '%{fandeck}'.",
            productFilter: "Filter proizvoda",
            searchInFormulas: "TraÅ¾ite u recepturama",
            typeMore: "Molimo unesite viÅ¡e karaktera"
        },
        menu: {
            actionHistory: "Istorijat akcija",
            additionalFormulaTab: "Dodatna kartica formule",
            advancedSettings: "Napredna podeÅ¡avanja",
            autotaskSettings: "PodeÅ¡avanja automatizacije",
            availableDatabases: "Dostupne baze podataka",
            availablePrices: "Dostupne cene",
            bugReport: "Prijava problema",
            canisterBarcodes: "Barkodovi kanistera",
            canisterDispensingLogic: "LogiÄko doziranje",
            canisterFilling: "Punjenje kanistera",
            canisterSettings: "PodeÅ¡avanje kanistera",
            clientServerSettings: "Veza klijenta/servera",
            closing: "Zatvaranje",
            color: "Boja",
            colorModification: "Modifikacija boja",
            colorPanel: "Color Palette Settings",
            colorRepresentation: "Reprezentacija boja i podataka",
            colorSearch: "PretraÅ¾ivanje boja",
            colorant: "Kolorant",
            colorantConsumption: "Colorant Consumption",
            colorantPricing: "Cena koloranta",
            colorantRefillHistory: "Istorija dopunjavanja koloranata",
            competitiveSearch: "Konkurentna pretraga koloranata",
            connections: "Veze",
            currency: "PodeÅ¡avanje valute",
            customData: "Custom Data",
            database: "Baza podataka",
            databaseCheck: "Provera baze podataka",
            databaseConnection: "Veza baze podataka",
            defaultValues: "Default Values",
            devices: "UreÄaji",
            dispensingHistory: "Istorijat doziranja",
            dispensingSettings: "PodeÅ¡avanja doziranja",
            driverSettings: "PodeÅ¡avanje drajvera",
            environment: "Okolina",
            environmentConfiguration: "PodeÅ¡avanje okoline",
            environmentalSettings: "PodeÅ¡avanja okoline",
            favorites: "Omiljeni",
            fileTransfer: "DESO File Transfer",
            formatting: "Formatting",
            formula: "Formula",
            formulaData: "Podaci",
            formulaModification: "Formula modification",
            formulaPanels: "Formula panela",
            formulaSettings: "PodeÅ¡avanja recepture",
            formulaUnit: "Formula jedinice",
            generalSearch: "OpÅ¡ta pretraga",
            globalSettingsSearch: "Global Settings Search",
            helpItems: "PomoÄ podeÅ¡avanja",
            importAndExport: "Unos i izvoz",
            importAndExportData: "Unos prilagoÄenih podataka",
            importCustomData: "Unos podataka",
            initialFormulaTab: "Tablica poÄetne formule",
            interfaceSettings: "PodeÅ¡avanja interfejsa",
            keyboardShortcuts: "PreÄice na tastaturi",
            language: "Jezik",
            languageSettings: "PodeÅ¡avanja jezika",
            layout: "Izgled",
            license: "Licenca",
            licenseData: "Podaci o licenci",
            licenseIdentification: "Identifikacija licence",
            licenseStatus: "Status licence",
            licenseSupplier: "DobavljaÄ licence",
            licenseVersion: "Verzija licence",
            localData: "Local Data",
            machine: "Informacije o maÅ¡ini",
            machineActions: "Akcije ureÄaja",
            machineAndDevices: "MaÅ¡ina i ureÄaji",
            machineManagement: "Upravljanje maÅ¡inom",
            machineSettings: "PodeÅ¡avanje maÅ¡ina",
            mainSettings: "Main Settings",
            maintenance: "OdrÅ¾avanje",
            marginAndDiscount: "Margin and discount",
            matchingSearchResult: "Matching search result",
            matchingSettings: "Matching Settings",
            navigationItems: "Predmeti navigacije",
            newFormulaWindow: "Receptura",
            orderSearch: "Pretraga narudÅ¾be",
            orderSettings: "PodeÅ¡avanja naruÄivanja",
            packageSurcharge: "Package Surcharge",
            popUps: "Pop-Ups",
            posInfo: "POS informacije",
            price: "PodeÅ¡avanje cene",
            priceManagement: "Upravljanje cenom",
            priceSettings: "PodeÅ¡avanje cene",
            pricingOptions: "Pricing Options",
            printSettings: "PodeÅ¡avanje Å¡tampanja",
            productPricing: "Cene proizvoda",
            qualityControlSettings: "Quality Control Settings",
            quickTint: "Brzo nijansiranje",
            rccConfig: "RCC podeÅ¡avanja",
            rccConnection: "RCC veze",
            rccSettings: "RCC podeÅ¡avanja",
            refillSettings: "Refill Settings",
            refillingLogic: "Refilling Logic",
            registration: "Registracija",
            searchSettings: "PodeÅ¡avanja pretrage",
            serverPlugins: "Dodaci za server",
            serviceActions: "Akcije servisa",
            settings: "PodeÅ¡avanja",
            simplifiers: "PojednostavljivaÄi",
            singleActions: "Pojedine akcije",
            smartPurgeRules: "Pravila pametnog ÄiÅ¡Äenja",
            softwareOptions: "Opcije softvera",
            spectroSettings: "PodeÅ¡avanja spektrometra",
            statistics: "Statistika",
            switchToFrontdesk: "Prebaci na prijem",
            switchToFullRedlike: "Prebaci na %{name}",
            switchToLight: "Prebaci na %{name}",
            switchToMachine: "Prabaci na maÅ¡inu",
            tabs: "Kartice i pop-ups",
            testBarcodes: "Testiranje barkoda",
            updateOptions: "Opcije aÅ¾ururanja",
            userManagemenet: "Upravljanje korisnicima",
            visibleUnits: "Vidljive jedinice"
        },
        navBar: {
            barcode: "Barkod",
            help: "PomoÄ",
            hideItems: "Hide products / fandecks"
        },
        notificationPanel: {
            noNotifications: "Nema novih obaveÅ¡tenja"
        },
        tabBar: {
            closeActive: "Zatvorite aktivne",
            closeAll: "Zatvorite sve",
            closeAllExceptActive: "Zatvorite sve osim aktivnih",
            customFormula: "Custom Formula",
            dispensingHistory: "Istorijat doziranja",
            favorites: "Omiljeni",
            formulaSearch: "Formula search",
            rewriteSettings: "Re-write local settings"
        }
    },
    ordering: {
        assign: "Dodelite",
        assignment: "Dodeljivanje",
        createdDate: "Datum stvaranja",
        finishDispensing: "ZavrÅ¡iti doziranje",
        foundInOrders: "PronaÄeno u narudÅ¾bama",
        inactiveDatabase: "Receptura je iz neaktivne ili nepoznate baze podataka %{0}",
        inactiveUnknownDatabase: "Receptura je iz neaktivne ili nepoznate baze podataka ",
        newOrderReceived: "Primili ste novu narudÅ¾bu!",
        noOrderSelected: "Nije izabrana nijedna narudÅ¾ba",
        release: "Izdanje",
        status: {
            accepted: "PrihvaÄeno",
            canceled: "Otkazano",
            created: "Kreirano",
            done: "UraÄeno",
            partlyDone: "DelimiÄno uraÄeno",
            preparing: "U pripremi",
            unknown: "Nepoznato"
        }
    },
    partialUpdates: {
        applying: "Applying partial updates",
        cantBeUsedForYourDbVersion: "Updates can't be used for this database. Please update via Helper.",
        newVersionWillBeInstalled: "It will install the new version including all available partial updates.",
        noPartialUpdatesAvailable: "No partial updates available",
        outOfDate: "out of date!",
        partialUpdates: "Partial updates",
        partialUpdatesArePreparing: "Partial updates are preparing",
        partialUpdatesAvailable: "Partial updates available!",
        preparedUpdatesMessage: "The following partial updates are prepared to be applied",
        remindMeLater: "Remind me later (after %{time} minutes)",
        swOutOfDate: "The current version of the software is",
        updateAutomatically: "If you do not response, update will start automatically in: %{time} s",
        updateToNewVersion: "Update to the newest version",
        updateWillTakeMoreTime: "The update will take more time.",
        updatesApplied: "Partial updates were successfully applied.",
        updating: "Updating"
    },
    posInfo: {
        address: "Adresa",
        contactName: "Kontakt ime",
        contactPerson: "Kontakt osoba",
        identification: "Identifikacija",
        machineInformation: "Informacije o maÅ¡ini",
        pos: "Prodajno mesto",
        secondAddress: "Druga adresa",
        shopIdentification: "Identifikacija lokala",
        shopName: "Naziv lokala",
        url: "URL",
        zipCode: "PoÅ¡tanski broj"
    },
    priceTypeList: {
        priceBasePurchase: "Cena koÅ¡tanja za bazu",
        priceBaseSell: "Prodajna cena za bazu",
        priceBaseSellFull: "Sell full price for base",
        priceCntPurchase: "Cena koÅ¡tanja za kolorante",
        priceCntPurchaseByColorantName: "Cena koÅ¡tanja za %{0} kolorant",
        priceCntPurchaseByName: "Cena koÅ¡tanja za kolorante po nazivu",
        priceCntSell: "Prodajna cena za kolorante ",
        priceCntSellByColorantName: "Prodajna cena za %{0} kolorant",
        priceCntSellByName: "Prodajna cena za kolorante po nazivu",
        priceCntSellFull: "Sell full price for colorants",
        priceCntSellFullByColorantName: "Sell full price for %{0} colorant",
        priceCntSellFullByName: "Sell full price for colorants by name",
        priceGroupBarcode: "Price group barcode",
        priceMarginAll: "Margina za sva pakovanja",
        priceMarginPerPkg: "Margina za jedno pakovanje",
        priceSellPriceAll: "Prodajna cena za sva pakovanja",
        priceSellPricePerKg: "Prodajna cena po kilogramu",
        priceSellPricePerL: "Prodajna cena po litru",
        priceSellPricePerPkg: "Prodajna cena pa jednom pakovanju",
        priceSurchargeAll: "Prodajna cena za sva pakovanja",
        priceSurchargePerPkg: "Doplata za jedno pakovanje",
        priceTintPurchaseAll: "Cena koÅ¡tanja nijansiranja za sva pakovanja",
        priceTintPurchasePerPkg: "Cena koÅ¡tanja za jedno pakovanje",
        priceTintSellFullAll: "Tint sell full price for all packages",
        priceTintSellFullAllPerPackage: "Tint sell full price per package",
        priceTotalPurchaseAll: "Ukupna cena koÅ¡tanja za sva pakovanja",
        priceTotalPurchasePerKg: "Ukupna cena koÅ¡tanja po kilogramu",
        priceTotalPurchasePerL: "Ukupna cena koÅ¡tanja po litru",
        priceTotalPurchasePerPkg: "Ukupna cena koÅ¡tanja po jednom pakovanju",
        priceTotalSellFullAll: "Total sell full price for all packages",
        priceTotalSellFullPerKg: "Total sell full price per kilogram",
        priceTotalSellFullPerLiter: "Total sell full price per liter",
        priceTotalSellFullPerPackage: "Total sell full price per package"
    },
    pricing: {
        allBases: "Sve baze",
        allPackages: "Sva pakovanja",
        backup: "Backup",
        basesOfProduct: "Bases of %{productName}",
        colorantPricing: "Cena koloranta",
        export: "Preuzimanje",
        import: "Postavljanje",
        packagePricing: "Cena pakovanja",
        packageSurcharge: "Doplata pakovanja",
        packages: "Pakovanja",
        packagesOfProduct: "Packages of %{productName}",
        posCoeficient: "POS coeficient",
        priceGroupPricePerLiter: "Cenovna grupa po litru",
        priceGroups: "Cenovne grupe",
        pricePerLiter: "Cena po litru",
        productPricing: "Cena proizvoda",
        purchasePrice: "Nabavna cena",
        purchasePricePerLiter: "Nabavna cena po litru",
        sellPrice: "Sell price",
        surcharge: "Doplata"
    },
    print: {
        adminRightsRequired: "Admin rights are required to edit or create a new template.",
        allowAutomaticPrint: "Dopustite automatsko Å¡tampanje",
        allowPrintAfterDispensing: "Dopustite Å¡tampanje posle doziranja",
        allowPrintBeforeDispensing: "Dopustite Å¡tampanje pre doziranja",
        automaticPrint: "Automatsko Å¡tampanje",
        choosePrinter: "Å tampaÄ",
        chooseSettings: "Uredi podeÅ¡avanja",
        chooseTemplate: "Å ablon",
        copies: "Copies",
        createTemplate: "Create template",
        createTemplateHint: "Create a new template from scratch. Save it to the templates folder and restart RCC.",
        defaultPrinter: "Å tampaÄ",
        defaultSettings: "Default settings",
        defaultTemplate: "Zadani Å¡ablon",
        editTemplate: "Edit template",
        editTemplateHint: "Edit %{name}. Changes will be visible after RCC restart.",
        noEditTemplate: "No template to edit",
        noPrinterSelected: "Nije izabran nijedan Å¡tampaÄ",
        noPrintersAvailable: "Nema dostupnih Å¡tampaÄa",
        noTemplateSelected: "Nije izabran nijedan obrazac",
        noTemplatesAvailable: "Nema dostupnih Å¡ablona",
        numberOfCopies: "Broj kopija",
        openTemplateEditor: "Otvorite ureÄivanje Å¡ablona",
        printAfterDispensing: "Å tampanje posle doziranja",
        printAsImage: "Å tampanje kao slike",
        printBeforeDispensing: "Å tampanje pre doziranja",
        printOnRequest: "Å tampanje po zahtevu",
        printOptions: "Opcije Å¡tampanja",
        printPagesAfterDispensing: "Broj kopija posle doziranja kante",
        printPagesBeforeDispensing: "Broj kopija pre doziranja kante",
        printPreview: "Prikaz za Å¡tampanje",
        printSettings: "PodeÅ¡avanje Å¡tampanja",
        printTaskLinkVariable: "Link to a variable",
        printVariable: "Print variable",
        printerName: "Naziv Å¡tampaÄa",
        printerOptions: "Opcije Å¡tampaÄa",
        printerSettings: "PodeÅ¡avanje Å¡tampaÄa",
        quickTintTemplate: "Å ablon brzog nijansiranja",
        setDefaultPrinter: "Podesite zadati Å¡tampaÄ",
        setDefaultTemplate: "Podesite zadani Å¡ablon",
        setQuickTintTemplate: "Podesite Å¡ablon brzog nijansiranja",
        showPreviewDialogBeforePrint: "Show preview dialog before print",
        template: "Å ablon",
        templateName: "Naziv Å¡ablona",
        templateSettings: "PodeÅ¡avanja obrasca"
    },
    printTemplate: {
        baseCode: "Kod baze",
        baseName: "Naziv baze",
        bfs: "BSF",
        colorantType: "Colorant type",
        customerCity: "Grad kupca",
        customerEmail: "e-mail kupca",
        customerName: "Ime kupca",
        customerPhone: "Telefon kupca",
        customerStreet: "Ulica kupca",
        customerZipCode: "PoÅ¡tanski broj kupca",
        destinationOfUse: "Destination of use",
        infoBfsGrade: "BSF ocena",
        orderQrCode: "QR kod",
        packageOrderCount: "Package order count",
        posAddress: "POS adresa",
        posAddressSecond: "POS adresa 2",
        posCity: "POS grad",
        posContact: "POS kontakt",
        posEmail: "POS e-mail",
        posPhone: "POS telefon",
        posUrl: "POS URL",
        posZipCode: "POS poÅ¡tanski broj",
        priceBasePurchaseWithTax: "Cena koÅ¡tanja baze sa PDV-om",
        priceBaseSellWithTax: "Prodajna cena baze sa PDV-om",
        priceCntPurchaseWithTax: "Cena koÅ¡tanja koloranata sa PDV-om",
        priceCntTotalSellWithTax: "Prodajna cena koloranata sa PDV-om",
        priceMarginAllWithTax: "Margina za sva pakovanja sa PDV-om",
        priceMarginPerPkgWithTax: "Margina za jedno pakovanje sa PDV-om",
        priceSellPriceAllWithTax: "Prodajna cena za sva pakovanja sa PDV-om",
        priceSellPricePerKgWithTax: "Prodajna cena po kilogramu sa PDV-om",
        priceSellPricePerLWithTax: "Prodajna cena po litru sa PDV-om",
        priceSellPricePerPkgWithTax: "Prodajna cena po jednom pakovanju sa PDV-om",
        priceSurchargeAllWithTax: "Doplata za sva pakovanja sa PDV-om",
        priceSurchargePerPkgWithTax: "Doplata za jedno pakovanje sa PDV-om",
        priceTintPurchaseAllWithTax: "Cena koÅ¡tanja nijansiranja za sva pakovanja sa PDV-om",
        priceTintPurchasePerPkgWithTax: "Cena koÅ¡tanja nijansiranja za jedno pakovanje sa PDV-om",
        priceTotalPurchaseAllWithTax: "Ukupna cena koÅ¡tanja za sva pakovanja sa PDV-om",
        priceTotalPurchasePerKgWithTax: "Ukupna cena koÅ¡tanja po kilogramu sa PDV-om",
        priceTotalPurchasePerLWithTax: "Ukupna cena koÅ¡tanja po litru sa PDV-om",
        priceTotalPurchasePerPkgWithTax: "Ukupna cena koÅ¡tanja po jednom pakovanju sa PDV-om",
        productAltName: "Proizvod",
        recipeInline: "Receptura"
    },
    products: {
        bases: "Baze",
        numberOfProducts: "Broj proizvoda",
        packagesFor: "Pakovanja za",
        sizeOfPackage: "VeliÄina pakovanja"
    },
    purgeModal: {
        purgeAll: "ÄiÅ¡Äenje svega",
        purgeAllChannels: "ProÄistite sve kanale",
        purgeVolume: "Zapremina ÄiÅ¡Äenja",
        startPurge: "PoÄetak ÄiÅ¡Äenja"
    },
    qualityControl: {
        darker: "Darker",
        dispensedMeasuredFormula: "Dispensed (measured) formula",
        lighter: "Lighter",
        measureDispensedFormula: "Measure dispensed formula to calculate delta E",
        moreBlue: "More blue",
        moreGreen: "More green",
        moreRed: "More red",
        moreYellow: "More yellow",
        pleaseContinueToFormulaCorrection: "Please continue to formula correction",
        qualityControlFailed: "Quality control failed!",
        qualityControlPassed: "Quality control passed"
    },
    quickTint: {
        dispensingInProgress: "Doziranje u toku",
        dispensingIsNotAvailable: "Doziranje nije dostupno",
        machineNotConnected: "MaÅ¡ina nije povezana",
        noColorantsSelected: "Nijedan kolorant nije odabran",
        noPrinterAvailable: "Å tampanje se ne moÅ¾e izvrÅ¡iti jer nije dostupan nijedan Å¡tampaÄ.",
        noTemplateAvailable: "Å tampanje se ne moÅ¾e izvrÅ¡iti jer nije dostupan nijedan obrazac.",
        overMaxCanisterSize: "Jedna ili viÅ¡e koliÄina koloranata nije validna"
    },
    quickTintSettings: {
        alphabetically: "Po abecednom redu",
        byCanister: "Po kanisterz",
        closeAfterDispensing: "Zatvorite posle doziranja",
        closeBeforeDispensing: "Zatvorite pre doziranja",
        quickTintSettings: "PodeÅ¡avanje brzog nijansiranja",
        sorting: "Sortiranje",
        windowClosingRules: "Pravila zatvaranja prozora"
    },
    rccButtons: {
        abort: "prekid",
        all: "sve",
        cancel: "otkazati",
        continue: "nastaviti",
        help: "pomoÄ",
        ignore: "zanemariti",
        no: "ne",
        noToAll: "ne svemu",
        ok: "u redu",
        postpone: "odloÅ¾iti",
        resume: "rezime",
        retry: "ponoviti",
        skip: "preskoÄiti",
        yes: "da",
        yesToAll: "da svemu"
    },
    rccDialog: {
        98: "Molimo potvrdite %{0} bazu sa barkodom.",
        99: "Molimo unesite bazu %{0} i potvrdite (kliknite OK)",
        100: "Dispenzer je u stanju greÅ¡ke, resetovati greÅ¡ke?",
        101: "Dispenzer je u stanju greÅ¡ke, nije moguÄ nastavak",
        102: "Resetovanje nije uspelo, nije moguÄ nastavak",
        103: "Receptura sadrÅ¾i nevalidan kolorant: %{0}",
        104: "Receptura sadrÅ¾i nevalidne kolorante: %{0}",
        105: "Kolorant: %{0} je ispod nivoa upozorenja",
        106: "Koloranti: %{0} su ispod nivoa upozorenja",
        107: "Kolorant: %{0} je ispod kritiÄnog nivoa",
        108: "Koloranti: %{0} su ispod kritiÄnog nivoa",
        109: "PoloÅ¾aj kante",
        110: "Postavite kantu sa bazom: %{0} za recepturu: %{1}",
        111: "Uklonite  kantu",
        112: "BuÅ¡enje kante?",
        113: "Resetovanje greÅ¡aka, molimo saÄekajte",
        114: "Pomeranje police, molimo saÄekajte",
        115: "Probijanje kante, molimo saÄekajte",
        116: "Doziranje recepture %{0}, molimo saÄekajte|Pakovanje: %{1} od %{2}|Proizvod: %{3}|Baza: %{4}|VeliÄina konte: %{5}",
        117: "Doziranje recepture %{0}, molimo saÄekajte|Pakovanje: %{1} od %{2}|Proizvod: %{3}|Baza: %{4}|VeliÄina konte: %{5}",
        118: "Doziranje, molimo saÄekajte|Pakovanje: %{0} od %{1}",
        119: "Doziranje, molimo saÄekajte|Pakovanje: %{0} od %{1}",
        120: "Otkazivanje doziranje, molimo saÄekajte",
        121: "Potvrditi barkod kante",
        122: "Potvrditi barkod baze kante |Proizvod: %{0}|Baza: %{1}|VeliÄina kante: %{2}",
        123: "Proces doziranja je prekinut, da li Å¾elite da nastaviti doziranje?",
        124: "Pojavila se greÅ¡ka u doziranju %{0} : %{1}. Da li Å¾elite da nastavite sa doziranjem?",
        125: "Proverite da li je postavljena prethodno koriÅ¡Äena kanta",
        126: "Obavezno koristite novu limenku jer c?e postupak doziranja kernuti ispoÄetka",
        127: "Kolorant: %{0} je ispod minimalne koliÄine doziranja. Da li Å¾elite da nastavite uprkos ovom upozorenju?",
        128: "Koloranti: %{0} su ispod minimalne koliÄine doziranja. Da li Å¾elite da nastavite uprkos ovom upozorenju?",
        129: "Odabrana receptura krÅ¡i pravilo prelivanja, ukupna koliÄina koloranata:%{0}%{1}, maksimalne dozvoljene koliÄine koloranata:%{2}%{3}. Da li Å¾elite da nastavite uprkos ovom upozorenju?",
        130: "Dispenzer je u stanju greÅ¡ke, resetovati greÅ¡ke?",
        131: "Dispenzer je u stanju greÅ¡ke, nije moguÄ nastavak",
        132: "Resetovanje nije uspelo, nije moguÄ nastavak",
        133: "Receptura ÄiÅ¡Äenja je prazna, nije moguÄ nastavak",
        134: "Receptura ÄiÅ¡Äenja sadrÅ¾i stavke koje se ne mogu oÄistiti, da li Å¾elite da nastavite?",
        135: "Postavite kantu za ÄiÅ¡Äenje",
        136: "Uklonite kantu za ÄiÅ¡Äenje",
        137: "Resetovanje greÅ¡aka, molimo saÄekajte",
        138: "Pomeranje police, molimo saÄekajte",
        139: "ÄiÅ¡Äenje, molimo saÄekajte",
        140: "ÄiÅ¡Äenje, molimo saÄekajte",
        141: "Otkazivanje ÄiÅ¡Äenja, molimo saÄekajte",
        142: "Nedostaje kanta za ÄiÅ¡c?enje, proverite da li je kanta pravilno postavljena",
        143: "Receptura ÄiÅ¡Äena sadrÅ¾i stavke koje se ne mogu oÄistiti, da li Å¾elite da nastavite?",
        144: "Postavite kantu za ÄiÅ¡Äenje",
        145: "Priprema, molimo saÄekajte",
        146: "ZavrÅ¡avanje, molimo saÄekajte",
        150: "ÄiÅ¡Äenje, molimo saÄekajte",
        151: "ÄiÅ¡Äenje, molimo saÄekajte",
        152: "Otkazivanje ÄiÅ¡Äenja, molimo saÄekajte",
        160: "Recirkulacija, molimo saÅ¡ekajte",
        161: "Recirkulacija, molimo saÅ¡ekajte",
        162: "Otkazivanje recirkulacije, molimo saÄekajte",
        170: "MeÅ¡anje, molimo saÄekajte",
        171: "MeÅ¡anje, molimo saÄekajte",
        172: "Otkazivanje meÅ¡anja, molimo saÄekajte",
        180: "Iniciranje veze sa dispenzerom, molimo saÄekajte",
        181: "Nije moguc?e uspostaviti vezu sa dispenzerom %{0}: %{1}",
        182: "Nije moguc?e uspostaviti vezu sa dispenzerom. Pogledajte datoteke prijave za viÅ¡e informacija",
        183: "Nedostaje kolorant u dispenzeru: %{0} koji je definisan u vaÅ¡oj bazi podataka",
        184: "Nedostaju koloranti u dispenzeru: %{0} koji je definisan u vaÅ¡oj bazi podataka",
        185: "Zatvaranje veze sa dispenzerom, molimo saÄekajte",
        190: "Da biste nastavili zatvorite usluÅ¾ni prozor",
        200: "Resetovanje, molimo saÄekajte",
        201: "TeÅ¡ko resetovanje, molimo saÄekajte",
        202: "Inicijalizacija, molimo saÄekajte",
        203: "Resetovanje greÅ¡aka, molimo saÄekajte",
        205: "Otvaranje autocap-a, molimo saÄekajte",
        206: "Zatvaranje autocap-a, molimo saÄekajte",
        207: "Pomeranje autocap-a, molimo saÄekajte",
        210: "BuÅ¡enje, molimo saÄekajte",
        211: "PrikljuÄivanje, molimo saÄekajte",
        215: "Pomeranje police na gore, molimo saÄekajte",
        216: "Pomeranje police na dole, molimo saÄekajte",
        217: "Pomeranje police, molimo saÄekajte",
        220: "Pomeranje stola za dopunjavanje: %{0}, molimo saÄekajte",
        221: "Pomeranje stola u poÄetni poloÅ¾aj, molimo saÄekajte",
        222: "Pomeranje stola, molimo saÄekajte",
        230: "Dispenzer je zauzet, molimo saÄekajte",
        240: "Molimo dopunite kanister %{0}",
        241: "Molimo dopunite kanister %{0}",
        242: "Pozicioniranje kanistera: %{0} (%{1}) u poloÅ¾aju za ponovno punjenje",
        243: "Molimo napunite kanister %{0} pomocÌu barkoda",
        244: "Molimo napunite kanister %{0} pomocÌu barkoda",
        250: "Sklonite posudu sa Äetkicom, oÄistite je i napunite vodom u skladu sa uputstvima",
        251: "Vratite posudu sa Äetkicom",
        254: "Otvaranje autocap-a ",
        255: "OÄistite autocap prema uputstvima",
        256: "Potvrdite kada ÄiÅ¡c?enje bude zavrÅ¡eno i autocap bude na mestu",
        257: "Zatvaranje autocap-a",
        260: "Skinite prekidaÄku ploÄu i oÄistite je",
        261: "Vratite prekidaÄku ploÄu",
        265: "OÄistite maÅ¡inu krpom i uklonite svu boju ili drugu teÄnost",
        266: "Potvrdite kada je zavrÅ¡eno",
        270: "Napunite posudu vode ovlaÅ¾ivaÄa i potvrdite kada je zavrÅ¡eno",
        271: "Napunite posudu vode ovlaÅ¾ivaÄa i potvrdite kada je zavrÅ¡eno",
        272: "Nivo vode je i dalje nizak, proverite ponovo",
        273: "Nivo vode je i dalje nizak, proverite ponovo",
        274: "Proverite nivo vode u posudi ovlaÅ¾ivaÄa i dopunite ga ako ima potrebe",
        275: "Molimo saÄekajte",
        280: "Restartovanje raÄunara",
        281: "IskljuÄenje raÄunara",
        300: "Baza kante nedostaje, proverite da li je kanta pravilno postavljena",
        301: "Priprema, molimo saÄekajte",
        302: "ZavrÅ¡avanje, molimo saÄekajte",
        303: "Receptura se ne moÅ¾e nijansirati jer sadrÅ¾i kolorant: %{0} koji je preko maksimalne koliÄine doziranja definisane za kanistar",
        304: "Receptura se ne moÅ¾e nijansirati jer sadrÅ¾i kolorant: %{0} koji je preko maksimalne koliÄine doziranja definisane za kanistere",
        305: "Kolorant: %{0} ne moÅ¾e biti doziran odjednom, da li Å¾elite da podelite recepturu?",
        306: "Koloranti: %{0} ne moÅ¾e biti doziran odjednom, da li Å¾elite da podelite recepturu?",
        307: "Kolorant: %{0} nec?e biti doziran od dispenzera, da li Å¾elite da nastavite i dodate ga ruÄno?",
        308: "Koloranti: %{0} nec?e biti dozirani od dispenzera, da li Å¾elite da nastavite i dodate ih ruÄno?",
        309: "Odabrana receptura je prazna, koristite bazu kante takva kakva je",
        310: "Nijedan kolorant ne moÅ¾e da se dozira, pripremite bazu za ruÄno dodavanje koloranta",
        311: "Sklonite bazu i pripremite je za ruÄno dodavanje koloranta",
        312: "Dodajte ruÄno %{0} %{1} koloranta: %{2}, potvrdite kada je spremno",
        313: "RuÄno dozirajte recepturu",
        314: "Odabrana formula krÅ¡i pravilo prelivanja, ukupna koliÄina koloranata: %{0} %{1}, maksimalne dozvoljene koliÄine bojila: %{2} %{3}. Da li Å¾elite da nastavite uprkos ovom upozorenju?",
        315: "Scan or type UFI code of base can",
        316: "Scan or type UFI code of base can|Product: %{0}|Base: %{1}|Can size: %{2}",
        317: "Prepare colorant: %{0} for manual addition, confirm when done",
        318: "Prepare colorants: %{0} for manual addition, confirm when done",
        319: "Add manually colorant: %{0}, confirm when done",
        320: "Add manually colorants: %{0}, confirm when done",
        400: "Zadatak automatskog ÄiÅ¡c?enja Äe biti pokrenut",
        401: "Zadatak automatskog ÄiÅ¡c?enja Äe biti pokrenut",
        405: "Posudu sa Äetkicom treba odrÅ¾avati",
        406: "Posudu sa Äetkicom treba odrÅ¾avati",
        410: "Pokrec?e se automatsko odrÅ¾avanje poklopca",
        411: "Pokrec?e se automatsko odrÅ¾avanje poklopca",
        415: "PloÄa s prekidaÄem mora biti oÄiÅ¡Äena",
        416: "PloÄa s prekidaÄem mora biti oÄiÅ¡Äena",
        420: "Dispenzer mora biti oÄiÅ¡c?en",
        421: "Dispenzer mora biti oÄiÅ¡c?en",
        425: "Pokrec?e se ponovno punjenje kanistra",
        426: "Pokrec?e se ponovno punjenje kanistra",
        430: "Zakazano je ponovno pokretanje raÄunara",
        431: "Zakazano je ponovno pokretanje raÄunara",
        435: "IskljuÄivanje raÄunara je zakazano",
        436: "IskljuÄivanje raÄunara je zakazano",
        440: "ÄiÅ¡c?enje dispenzera je zakazano",
        441: "ÄiÅ¡c?enje dispenzera je zakazano",
        445: "Recirkulacija dispenzera je zakazana",
        446: "Recirkulacija dispenzera je zakazana",
        450: "MeÅ¡anje dispenzara je zakazano",
        451: "MeÅ¡anje dispenzara je zakazano",
        990: "DoÅ¡lo je do greÅ¡ke dispenzera %{0} : %{1}. Da li Å¾elite ponovo da pokuÅ¡ate?",
        991: "DoÅ¡lo je do interne greÅ¡ke: %{0}",
        200000001: "Postavite kantu",
        200000002: "Uklinite kantu",
        200000003: "Iznos za '%{0}' ispod minimalnog iznosa doziranja, nastavite na sopstveni rizik?",
        200000004: "Dopunite '%{0}'"
    },
    rccDriverSettings: {
        databasePath: "Putanja baze podataka",
        dispenser: "Dispenzer",
        dispenserConfigurationFile: "Konfiguraciona datoteka dispenzera",
        driverPath: "Putanje drajvera",
        extensionPath: "Putanja produÅ¾enja",
        folder: "Fascikla",
        formulaPath: "Putanje formule",
        host: "Host",
        iddPath: "IDD datoteka konfiguracije",
        italtintoPath: "Italtinto putanja konfiguracije",
        lldPath: "LLD putanja",
        machineType: "Tip maÅ¡ine",
        noMachineAvailable: "Nema dostupnog ureÄaja",
        protocolVersion: "Verzija protokola",
        rccDriverSettings: "PodeÅ¡avanje drajvera",
        resultPath: "Putanja rezultata",
        save: "SaÄuvaj podeÅ¡avanja",
        saveSettingsWarning:
            "Upozorenje! Promene u ovom odeljku mogu prouzrokovati neispravno funkcionisanje dispenzera",
        serviceSwPath: "Putanja servisiranja softvera",
        simulationPath: "Putanja simulacije"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "Dozvolite ruÄno dodavanje koloranata",
        ask: "Pitati",
        canHandlingOptions: "Opcije rukovanja kantom",
        checkCanBeforeDispense: "Proverite kantu pre nego da dozirate",
        checkOverfill: "Proverite prepunjenost",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantPackageValidation: "Colorant package validation only",
        disable: "Onemoguc?iti",
        dispenseInvalidColorants: "Distribujrajte pogreÄÅ¡ne kolorante",
        dispensingOptions: "Opcije doziranja",
        enable: "OmoguÄiti",
        enableUserIdentification: "User identification",
        fullValidation: "Full validation",
        machineAccuracyWarning: "Upozorenje o preciznosti maÅ¡ine",
        machineOptions: "Opcije maÅ¡ine",
        machineUnit: "Jedinica maÅ¡ine",
        minimalDispenseAmount: "Doziranje min. KoliÄine",
        placeCanSensor: "Senzor pozicioniranja kante",
        placeCanSensorDelay: "Odlaganje senzora pozicioniranja kante",
        rccMachineSettings: "PodeÅ¡avanje maÅ¡ine",
        refillBarcodeValidation: "Refill barcode validation",
        refillBarcodeValidationCanisterAndColorant: "Validate Canister and Colorant package",
        refillBarcodeValidationColorant: "Validate only colorant package",
        refillSettings: "Refill settings",
        removeCanSensor: "PoniÅ¡tite senzor kante",
        removeCanSensorDelay: "PoniÅ¡tite odlaganje senzora kante",
        save: "SaÄuvaj podeÅ¡avanja",
        sec: "sekund",
        skipPlaceCanDialog: "PreskoÄiti dijaloga pozicioniranja kante",
        skipRemoveCanDialog: "PreskoÄite dijalog za uklanjanje kante",
        splitFormula: "Deliti recepturu",
        tmcEnabled: "Omoguc?iti TMC",
        ufiCode: "UFI code",
        validateBarcodeBaseCan: "Potvrdite barkod kante baze",
        validateBarcodeRefill: "Potvrdite barkod pre ponovnog punjenja",
        validateColorantsDuringInit: "Potvrdite kolorante u toku inicijalizacije"
    },
    rccPanel: {
        actionsRunningOnDispenser: "U maÅ¡ini su u toku neke akcije",
        addLevel: "DODAJTE NIVO",
        addManually: "Add manually",
        barcodeNotSet: "Canister %{colorantName} (%{canisterName}) has no barcode assigned.",
        cancel: "PONIÅ TITI",
        dispenseFormula: "Receptura za doziranje",
        dispenserIdle: "MaÅ¡ina radi u praznom hodu",
        dispenserIsBusy: "MaÅ¡ina je zauzeta",
        dispenserIsIdle: "MaÅ¡ina radi u praznom hodu",
        dispenserIsReady: "MaÅ¡ina je spremna za dalje zadatke",
        dispensingFormula: "Doziranje recepture",
        errorCode: "Å ifra greÅ¡ke",
        explanation: "ObjaÅ¡njenje",
        fillToMax: "Dopunite max.",
        finished: "Finished",
        inProgress: "In progress",
        machineIsReady: "MaÅ¡ina je spremna  ",
        moveToFill: "Pomerite da bi napunili",
        noMachineDialog: "Nijedna maÅ¡ina nije povezana",
        of: "od ",
        packageSize: "VeliÄina pakovanje",
        placeBaseCan: "Postavite kantu baze",
        pleaseCheckYourMachineConnection: "Molimo proverite povezivanje maÅ¡ine sa raÄunarom",
        pleaseRefill: "Molimo dopunite  ",
        solution: "ReÅ¡enje",
        subErrors: "PodgreÅ¡ke",
        timeToEnd: "Vreme i kraj",
        tintingFormula: "Receptura nijansiranja",
        tintingPleaseWait: "Nijansiranje je u toku, molimo saÄekajte",
        validateBaseCan: "Potvrdite kantu baze",
        waiting: "Waiting"
    },
    rccSettigns: {
        rccSettigns: "RCC veza",
        rccUrl: "RCC url"
    },
    rccSpectroDialog: {
        100: "Povezivanje sa VaÅ¡im ureÄajem preko Bluetooth-a. Proverite da li je omoguc?en Bluetooth i da li je instrument ukljuÄen.",
        101: "Instrument nije pronaÄen. Da li Å¾elite da pokuÅ¡ate ponovo?",
        110: "Budite sigurni da je Nano prikaÄen i pritisnite taster instrumenta da biste zapoÄeli inicijalizaciju",
        111: "Nano nije pronaÄen. Da li Å¾elite da pokuÅ¡ate ponovo? ",
        112: "Diskonektovan Nano, saÄekajte 10 sekundi, poveÅ¾ite ga ponovo i nastavite",
        120: "Povezuje se na vaÅ¡ ureÄaj, molimo priÄekajte",
        121: "Instrument nije pronaÄen. Da li Å¾elite da pokuÅ¡ate ponovo?",
        200: "Postavite instrument na crnu ploÄicu i nastavite ili pritisnite taster instrumenta",
        201: "Postavite instrument na crnu ploÄicu i nastavite ",
        202: "Postavite instrument na crnu ploÄicu i pritisnite taster instrumenta",
        205: "Postavite instrument na belu ploÄicu i nastavite ili pritisnite taster instrumenta",
        206: "Postavite instrument na belu ploÄicu i nastavite ",
        207: "Postavite instrument na belu ploÄicu i pritisnite taster instrumenta",
        210: "Postavite instrument na dijagnostiÄku ploÄicu i nastavite ili pritisnite taster instrumenta",
        211: "Postavite instrument na dijagnostiÄku ploÄicu i nastavite ",
        212: "Postavite instrument na dijagnostiÄku ploÄicu i pritisnite taster instrumenta",
        215: "Zatvorite poklopac instrumenta i nastavite ili pritisnite taster instrumenta",
        216: "Zatvorite poklopac instrumenta i nastavite",
        217: "Zatvorite poklopac instrumenta i pritisnite taster instrumenta",
        220: "Postavite instrument na nultu ploÄicu i nastavite ili pritisnite taster instrumenta",
        221: "Postavite instrument na nultu ploÄicu i nastavite ",
        222: "Postavite instrument na nultu ploÄicu i pritisnite taster instrumenta",
        224: "Place the instrument on calibration pad and continue or press instrument button",
        225: "Place the instrument on calibration pad and continue",
        226: "Place the instrument on calibration pad and press instrument button",
        227: "Place the instrument on calibration pad and press instrument button",
        295: "ZavrÅ¡ite kalibraciju u prozoru drajvera",
        296: "Instrument is not connected, do you want to open connection to it?",
        297: "Priprema se za kalibraciju, molimo saÄekate",
        298: "Kalibracija u toku, molimo saÄekajte",
        299: "ZavrÅ¡ni korak kalibracije, molimo saÄekajte",
        300: "Postavite instrument na uzorak i nastavite ili pritisnite taster instrumenta",
        301: "Postavite instrument na uzorak i nastavite ",
        302: "Postavite instrument na uzorak i pritisnite taster instrumenta",
        303: "Instrument is not calibrated, do you want to proceed with calibration?",
        304: "Instrument is not connected, do you want to open connection to it?",
        390: "Select measure mode",
        395: "ZavrÅ¡ite merenje u prozoru drajvera",
        397: "Pripremite se za merenje, molimo saÄekajte",
        398: "Merenje, molimo saÄekajte",
        399: "ZavrÅ¡ava se merenje, molimo saÄekajte",
        498: "Preuzimanje merenja, molimo saÄekajte",
        499: "Preuzimanje svih merenja, molimo saÄekajte",
        900: "DoÅ¡lo je do greÅ¡ke instrumenta %{0} : %{1}. Da li Å¾elite ponovo da pokuÅ¡ate?",
        901: "DoÅ¡lo je do interne greÅ¡ke: %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "RaÄunar mora imati bluetooth vezu. Spektrometar mora biti uparen sa raÄunarom. Neophodan je Windows 10 sa aÅ¾uriranjem za jesen 2018. godine.",
        DatacolorSilent:
            "Kada koristite neÄujni reÅ¾im, Datacolor prozori se prikazuju direktno u %{name}. U ovim prozorima parametri spektrometra se ne mogu menjati.",
        DatacolorUseDiagnosticTile: "KoriÅ¡cÌenje dijagnostiÄke ploÄice poboljÅ¡ava kvalitet merenja.",
        comPort: "COM Port",
        diagnosticTile: "Datacolor koristi dijagnostiÄku ploÄicu",
        measureModes: "Measure modes",
        measureModesOrder: "Measure modes order",
        model: "Model ",
        noSpectroAvailable: "Nije dostupan spektar",
        rccSpectroSettings: "PodeÅ¡avanje spektrometra",
        save: "SaÄuvaj podeÅ¡avanje",
        silent: "Datacolor nemi",
        simulationPath: "Putanje simulacije",
        spectroType: "Tip sprektrometra",
        useProfiledValues: "Koristite profilisane vrednosti"
    },
    recirculateChannels: {
        recirculateAllChannels: "Recirkulirajte sve kanale",
        recirculateChannels: "Recirkulirajte kanale",
        recirculatingSpeed: "Brzina recirkulacije",
        recirculatingTime: "Vreme recirkulacije",
        startRecirculating: "ZapoÄnite recirkulaciju"
    },
    redlikeLight: {
        finishPreviousSteps: "Molimo zavrÅ¡ite prethodne korake",
        searchBySpectro: "PretraÅ¾ite sa spektrometrom",
        searchFormula: "PotraÅ¾ite recepture",
        selectBase: "Select base",
        selectColor: "Izaberite boju",
        selectCustomer: "Izaberite kupca",
        selectFandeck: "Izaberite kolor kartu",
        selectPackage: "Izaberite pakovanje",
        selectProduct: "Izaberite proizvod",
        startSelectFandeck: "ZapoÄnite odabirom kolor karte",
        startSelectProduct: "ZapoÄnite odabirom proizvoda",
        stepByStepProgress: "MoÅ¾ete napredovati korak po korak",
        typeHereToSearch: "Otkucajte ovde da biste pretraÅ¾ili",
        typeToFilter: "Otkucajte za filtriranje"
    },
    restartModal: {
        computerNeedsRestart: "RaÄunar treba ponovo pokrenuti!",
        notCompletelyTranslated:
            "Za promenu jezika potreban je restartovanje softvera. Neki delovi softvera trenutno nisu u potpunosti prevedeni.",
        restartIsRequired: "Software restart is required after the changes have been made.",
        softwareNeedsRestart: "%{name} Potrebno je restartovanje!"
    },
    searchPanel: {
        basePlaceholder: "or type a base name",
        baseStartPlaceholder: "Start by typing a base name",
        colorCodeNamePlaceholder: "or type a formula code/name",
        colorCodeNameStartPlaceholder: "Start by typing a formula code/name",
        colorCodePlaceholder: "ili otkucaj Å¡ifru recepture",
        colorCodeStartPlaceholder: "ZapoÄnite upisivanjem koda formule",
        colorNameCodePlaceholder: "or type a formula name/code",
        colorNameCodeStartPlaceholder: "Start by typing a formula name/code",
        colorNamePlaceholder: "ili otkucaj naziv recepture",
        colorNameStartPlaceholder: "ZapoÄnite upisivanjem naziva formule",
        colorPreviewIsNotAvailable: "Color preview is not available. Select a fandeck to see relevant color preview.",
        fandeckPlaceholder: "ili otkucaj naziv kolor karte",
        fandeckStartPlaceholder: "ZapoÄnite upisivanjem naziva kolor karte",
        formulaByColor: "Recepture po bojama",
        noResultsFound: "No results found",
        packagePlaceholder: "or type a package name",
        packageStartPlaceholder: "Start by typing a package name",
        productPlaceholder: "ili otkucaj naziv proizvoda",
        productStartPlaceholder: "ZapoÄnite kucanjem naziva proizvoda",
        standard: "Standardno",
        typeFandeckToFilter: "Unesite ovde da biste filtrirali po imenu kolor karte",
        typeProductToFilter: "Unesite ovde da biste filtrirali po imenu naziva"
    },
    sendOrderModal: {
        customNote: "PrilagoÄena beleÅ¡ka",
        noCompatibleServers: "U vaÅ¡oj mreÅ¾i nisu dostupni kompatibilni serveri",
        orderOverview: "Pregled narudÅ¾be",
        selectTargetMachine: "Izaberite ciljnu maÅ¡inu",
        sendOrder: "PoÅ¡aljite narudÅ¾bu",
        sendOrderTo: "VaÅ¡a narudÅ¾ba c?e biti poslata na %{serverName}",
        targetMachine: "Ciljna maÅ¡ina"
    },
    server: {
        computerId: "ID raÄunara",
        ip: "IP",
        selectServer: "Molimo izaberite jedan od dostupnih servera",
        server: "Server"
    },
    serverDialog: {
        1: "There is an error in the brand definition for your license. Please check with your provider.",
        2: "Could not process data for %{0}: %{1}",
        3: "Invalid network path.",
        4: "Invalid path type (only %{0} and %{1} types are supported)",
        5: "Error writing tinting file.",
        6: "Tinting file was created successfully.",
        7: "Could not find colorant with name: '%{0}' on row '%{1}'",
        8: "Could not find package with name: '%{0}' on row '%{1}'",
        9: "Could not find base in product with product name: '%{0}' and base name: '%{1}' on row '%{2}'",
        10: "Could not find base in product package with product name: '%{0}', base name: '%{1}' and package name: '%{2}' on row '%{3}'",
        11: "Could not parse price value: '%{0}' on row '%{1}' in sheet '%{2}'",
        12: "Preparing bases data, please wait",
        13: "Preparing bases in products data, please wait",
        14: "Preparing base packages data, please wait",
        15: "Preparing colors data, please wait",
        16: "Preparing colors in fandecks data, please wait",
        17: "Preparing fandecks data, please wait",
        18: "Preparing data for global search, please wait",
        19: "Preparing products data, please wait",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "Partial updates can't be applied on database '%{0}'. Database versions doesn't match. Contact your technical support.",
        32: "Partial updates can't be applied on database '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. The update is corrupted. Contact your technical support.",
        34: "Unknown error occurred during partial update. If this error repeats contact your technical support.",
        35: "No partial updates available. Please check your internet connection or contact your technical support.",
        36: "Prepared partial updates for database '%{0}' are for newer version of Redlike. Update your Redlike to the latest version. Minimal required version is '%{1}'.",
        37: "Partial updates can't be prepared. There is not enough space on the drive. Minimal required space is 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "Aktivni dodaci servera",
        currentlyActive: "Trenutno aktivni dodaci",
        plugin: "Povezati",
        pluginName: "Povezati ime",
        statusActive: "Aktivan",
        statusInactive: "Neaktivan"
    },
    serviceActionsSettings: {
        canisterLevel: "Nivo kanistera",
        capClose: "Zatvoreni",
        capMiddle: "Srednji",
        capOpen: "Otvoreni",
        cleanAllChannels: "OÄistite sve kanale",
        cleanChannels: "OÄistite kanale",
        computer: "RaÄunar",
        computerReboot: "Restartovanje raÄunara",
        computerShutdown: "IskljuÄenje raÄunara",
        connectMachine: "PoveÅ¾ite maÅ¡inu",
        general: "OpÅ¡te",
        initialize: "Inicijalizirajte",
        noMachineIsConnected: "Nijedna maÅ¡ina nije povezana",
        plug: "PrikljuÄite",
        plugger: "PrikljuÄak",
        punch: "BuÅ¡iti",
        puncher: "BuÅ¡aÄ",
        purgeChannels: "ProÄistite kanale",
        recirculate: "Recirkulacija",
        recirculateAllChannels: "Recirkulirajte sve kanale",
        recirculateChannels: "Recirkulirajte kanale",
        serviceActions: "Akcije servisiranja",
        setCanisterLevel: "Podesite nivo kanistera",
        shelfDown: "Polica prema dole",
        shelfUp: "Polica prema gore",
        showServiceWindow: "PrikaÅ¾i prozor usluge",
        smartPurgeAllChannels: "Smart purge all channels",
        smartPurgeChannels: "Smart purge channels",
        startErrorReset: "PoniÅ¡ti poÄetnu greÅ¡ku",
        startHardReset: "PoÄnite vraÄanje na fabriÄka podeÅ¡avanja",
        startReset: "Pokrenite resetovanje",
        stirAllCanisters: "PomeÅ¡ajte sve kanistere",
        stirCanisters: "PomeÅ¡ajte kanistere",
        stirCanistersMore: "PomeÅ¡ajte kanistere"
    },
    spectroMode: {
        eggshell: "Eggshell",
        flat: "Flat",
        gloss: "Gloss",
        matt: "Matt",
        matte: "Matte",
        pearl: "Pearl",
        satin: "Satin",
        selectGlossLevel: "Compare the color sample to the gloss scale and select gloss level",
        semiGloss: "Semi-Gloss"
    },
    spectroTab: {
        bestMatch: "The best match",
        calibrate: "Kalibracija  ",
        calibrateInstrument: "Calibrate instrument",
        connectDevice: "PoveÅ¾ite ureÄaj",
        connectedTo: "Povezan",
        connectingDevice: "Povezivanje VaÅ¡eg ureÄaja",
        deselectAll: "PoniÅ¡tite sve",
        deviceCalibrated: "Your device has been calibrated and you can start measuring",
        deviceIsNotCalibrated: "VaÅ¡ ureÄaj nije kalibriran",
        eraseResult: "Erase result",
        filter: "Filter",
        foundInFormulas: "PronaÄite u recepturama",
        inactiveSpectro: "The Spectro function is inactive for selected brand.",
        instrumentCalibration: "Your instrument needs to be calibrated.",
        manualInput: "Manual input",
        measure: "Measure",
        measurementResult: "Rezultat merenja",
        noFilters: "Nema dostupnih filtera",
        noFormulas: "Nisu pronaÄene recepture",
        noSelectedSpectro: "Nije izabran spektrometar",
        notSelected: "Nije izabran",
        pressConnectButton: "Proverite da li je VaÅ¡ ureÄaj povezan i pritisnite taster za povezivanje",
        searchFormulas: "PretraÅ¾ite recepture",
        selectSpectro: "Izaberite spektrometar",
        showDetails: "PrikaÅ¾ite detalje",
        skipCalibration: "Skip calibration",
        spectroIsConnected: "Spektrometar je povezan",
        spectroIsReady: "Spektrometar je spreman",
        spectroReady: "UreÄaj je spreman za dalje zadatke",
        startCalibrateNow: "Start calibrate now",
        startMeasureText: "VaÅ¡ ureÄaj je kalibrisan i moÅ¾ete da poÄnete sa merenjima",
        tolerance: "Delta E (CIE 2000)",
        toleranceOfDevitation: "Delta E (CIE 2000) tolerancija "
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "PrilagoÄeni %{1} %{2}",
        deleteSelectedRecords: "IzbriÅ¡ite odabrane zapise",
        exportHistory: "Preuzimanje istorijata",
        finishFormula: "ZavrÅ¡na receptura",
        foundInFormulas: "PronaÄite u recepturama",
        hideHiddenRecords: "Ne prikaÅ¾i skrivene zapise",
        hideSelectedRecord: "Sakrij izabrani zapis",
        historicalFormula: "Historical formula",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "Vrati izabrani zapis",
        showAllRecords: "PrikaÅ¾i sve zapise",
        standardFormula: "Standard formula",
        unknownFormula: "Unknown formula"
    },
    stirCanisters: {
        selectCanisters: "Izaberite kanistere",
        startStirring: "Pokrenite meÅ¡anje",
        stirAllCanisters: "PromeÅ¡ajte sve kanistere",
        stirCanisters: "PromeÅ¡ajte kanistere",
        stirringSpeed: "Brzina meÅ¡anja",
        stirringTime: "Vreme meÅ¡anja"
    },
    stock: {
        addColorant: "Add colorant...",
        addColorantPackagesToStock: "Add colorant packages to stock",
        addPackagesToStock: "Add packages to stock",
        addedToStock: "Added to stock",
        allDatabases: "All databases",
        checkStockPackageInventory: "If you used package from stock, please check if your stock inventory is valid.",
        clearAllItems: "Clear all items",
        colorantInventory: "Colorant inventory",
        colorantsStockInventory: "Colorants stock inventory",
        confirmSendingOrder: "Confirm sending order",
        consumptionPrediction: "Consumption prediction for the next %{weeks} weeks",
        createOrder: "Create order (%{sum})",
        expirationDate: "Expiration date",
        inDelivery: "In delivery",
        manualOrder: "Manual order",
        manualOrderProgress: "Step %{step}/%{total}",
        noPackagesFoundInStockForColorant: "There are no packages in stock for this colorant.",
        onStock: "In stock",
        orderSummary: "Order summary",
        prediction: "Prediction",
        removePackageFromStock: "Remove %{colorantName} package from stock",
        removePackageNameFromStock: "Would you like to remove one %{packageName} package from stock?",
        scanBarcodeOrSelectColorant: "Scan barcode from package or select colorant",
        selectPackageToRemove: "Select package to remove",
        sendConfirmed: "Send confirmed",
        setAmountsByPrediction: "Set amounts by prediction",
        sortByColorantName: "Sort by colorant name",
        sortByOrderNeed: "Sort by need to order",
        sortByStockLevel: "Sort by stock level",
        toOrder: "To order"
    },
    testBarcode: {
        noItemAssigned: "Nijedna stavka nije dodeljena barkodu %{code}",
        pleaseScanBarcode: "Molimo, skenirajte barkod baze, proizvoda, pakovanja ili drugih predmeta",
        testBarcodes: "Testirajte barkod"
    },
    ticketing: {
        answer: "Answer",
        answered: "Answered",
        chooseType: "Choose type",
        closeRequest: "Close request",
        comment: "Comment",
        create: "Create",
        createNewTicket: "Create new ticket",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "Formula claim",
        formulaRequest: "Formula request",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "POS information (name, city) not found",
        noTicketSelected: "No ticket selected",
        openTicket: "Open ticket",
        posName: "POS name",
        posted: "Posted",
        request: "Request",
        requestDate: "Request date",
        requestId: "Request ID",
        resolvedBy: "Resolved by",
        responseDate: "Response date",
        saveToCustomFormula: "Save to custom formula",
        sending: "Sending",
        service: "Service",
        successfulCreation: "Ticket successfully created. Sending...",
        ticketAnswered: "A ticket has been answered.",
        ticketDelivered: "A ticket has been delivered.",
        ticketId: "Ticket ID",
        ticketType: "Ticket type",
        waitingForAnswer: "Waiting for answer"
    },
    tutorial: {
        last: "Poslednji",
        next: "SledeÄi"
    },
    ufiCodeModal: {
        currentStatus: "Current Status",
        detailedInfoForColorant: "Detailed info for colorant %{colorantName}",
        userSetUfiCode: "User set UFI code, current value"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "Base UFI code validation",
        confirmColorantRefilling: "Confirm colorant refilling",
        enableUfiCodes: "Enable UFI codes",
        printUfiCode: "Print if amount of colorant is over",
        printUfiCodePercentage: "Print percentage if amount of colorant is over",
        scanOrTypeUfiCode: "Scan or type UFI code",
        scanOrTypeUfiCodeOfBase: "Scan or type UFI code of base can",
        ufiCodesByPercentage: "Use UFI codes by percentage",
        ufiCodesFromDatabase: "Use UFI codes from the database",
        ufiCodesFromLastFilling: "Use UFI codes from the last filling"
    },
    userSettings: {
        addUser: "Dodaj korisnika",
        assignedUserGroups: "Dodeljene korisniÄke grupe",
        availableUserGroups: "Dostupne grupe korisnika",
        barcode: "Barkod",
        confirmNewPassword: "Potvrdite lozinku",
        editPassword: "Uredite lozinku",
        editUser: "Uredite korisnika",
        enableAutoLogin: "OmoguÄi automatsku prijavu",
        newPassword: "Nova lozinka",
        noChange: "Nema promene koje bi saÄuvali",
        oldPassword: "Stara lozinka",
        password: "Lozinka",
        passwordsDoNotMatch: "Lozinke se ne poklapaju",
        restoreUser: "Ovaj korisnik je obrisan. Å½elite li ga vratiti?",
        userGroup: "User Group",
        userGroups: "Grupa korisnika",
        userManagement: "Upravljanje korisnicima",
        userSettings: "PodeÅ¡avanje korisnika",
        username: "KorisniÄko ime",
        usernameIsMissing: "Nedostaje korisniÄko ime"
    },
    warningMissingDataModal: {
        continue: "Same data is missing, do you want continue?",
        notFoundBase:
            "This product base is not available. Confirm and be careful to get compatible product base from shelf or cancel this order.",
        notFoundProduct:
            "This product is not available. Confirm and be careful to get compatible product from shelf or cancel this order."
    },
    weekdays: {
        friday: "Petak",
        monday: "Ponedeljak",
        saturday: "Subota",
        sunday: "Nedelja",
        thursday: "Äetvrtak",
        tuesday: "Utorak",
        wednesday: "Sreda"
    },
    welcome: {
        availableDatabase: "Server se ne moÅ¾e povezati sa bazom podataka. Molimo proverite konfiguraciju baze podataka",
        availableDatabaseLocalError:
            "DoÅ¡lo je do greÅ¡ke tokom povezivanja sa lokalnom bazom podataka (pogreÅ¡na datoteka, nevaÅ¾ec?a lozinka)",
        availableDatabaseLocalMissing: "Nedostaje lokalna datoteka baze podataka",
        availableDatabaseLocalUpdate: "Lokalna baza podataka treba aÅ¾urirati na noviju verziju",
        availableDatabaseMainAndLocalError:
            "DoÅ¡lo je do greÅ¡ke prilikom povezivanja sobe, glavne i lokalne baze podataka (pogreÅ¡na datoteka, nevaÅ¾ec?a lozinka)",
        availableDatabaseMainAndLocalMissing: "Nedostaju glavne i lokalne datoteke baze podataka",
        availableDatabaseMainAndLocalUpdate: "I glavna i lokalna baza podataka moraju se aÅ¾urirati na noviju verziju",
        availableDatabaseMainError:
            "DoÅ¡lo je do greÅ¡ke tokom povezivanja sa glavnom bazom podataka (pogreÅ¡na datoteka, nevaÅ¾ec?a lozinka)",
        availableDatabaseMainMissing: "Nedostaje glavna datoteka baze podataka",
        availableDatabaseMainPartialUpdate: "Main database needs to be updated to the newer version via partial update",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "Main database needs to be updated to the newer version via partial update and local database needs to be updated to the newer version",
        availableDatabaseMainUpdate: "Glavna baza podataka mora se aÅ¾urirati na noviju verziju",
        closing: "Softver se iskljuÄuje",
        compatibility:
            "Molimo proverite verziju VaÅ¡eg servera. VaÅ¡ klijent je kompatibilan samo sa serverom %{0} ili novijim",
        compatibilityCheck: "Provera kompatibilnosti je u toku",
        compatibilityDatabase:
            "VaÅ¡a baza podataka nije kompatibilna sa serverom. Molimo proverite konfiguraciju baze podataka",
        connectingServer: "Povezivanje sa serverom na %{ip}",
        databaseCompatibility: "VaÅ¡a baza podataka nije kompatibilna sa trenutnim softverom",
        databasesCompatibility: "VaÅ¡e baze podataka nisu kompatibilne sa trenutnim softverom",
        licenseVerification: "Provera licence je u toku",
        loading: "UÄitavanje",
        lostConnection: "Veza sa serverom je prekinuta",
        moduleMessage:
            "Obratite paÅ¾nju na izbor modula, jer c?e buduc?e promene modula biti dostupne samo povlaÅ¡c?enim korisnicima",
        refresh: "OsveÅ¾iti",
        restoring: "Uspostavljene veze",
        selectModule: "Molimo Vas odaberite jednu od dostupnih modula",
        stopUpdate: "Prekinite aÅ¾uriranje",
        updateDatabase: "AÅ¾uriranje baze podataka",
        updatingDatabase: "Baza podataka se aÅ¾urira",
        updatingDatabases: "Baze podataka se aÅ¾uriraju",
        updatingWarning: "Database structure is being updated to the newest version, please wait.",
        updatingWarningInfo:
            "Do not close this window as it would result in the necessity to do the update from scratch."
    }
};
